export const data = {
  'introduce': {
    showContent: true, // 是否有内容介绍
    content: `
      <h1>平台简介</h1>
      <p>九科星资源开放平台，是指九科星教学网上优质的K12教育资源，开放给广大开发者。开发者使用所需的教学资源，以便完善自己的教育产品或项目建设，从而实现共赢。</p>
      <br>
      <p>内容方面，资源开放平台涵盖客户亟需的试题、试卷、课件、素材等教学资源，具有体系精细、质量佳、种类多的优势，并可提供个性化资源定制。
        开发者可通过资源开放平台灵活简便的对接方式，与九科星进行在线资源服务的合作。</p><br>
      <p>功能方面，可根据开发者的需要，利用平台中成熟完备的题库、资源库、校本库等组件高效地进行系统集成，支持多种方式的试题搜索、智能组卷，多维度的资料检索、在线备课，校本资源建设、个人文库管理等功能，从而完善开发者的产品。</p>
    `
  },
  'agreement': {
    showContent: true,
    content: `
      <h1>开发者协议</h1>
      <p>本服务条款是九科星资源开放平台网站（https://fuwu-open.jkxjxw.com/ 以下称为“本网站”）与开发者（即“用户”）共同缔结的对双方具有约束力的有效契约。开发者在注册为本网站用户前，需仔细阅读并完全理解本《协议》内容及本网站公布的其他服务规则，如果开发者不同意受该等服务条款的约束，应停止注册账号并停止使用本网站服务。</p>
      <p>当开发者点击本网站注册页面的同意注册按钮并完成注册程序、获得本网站账号和密码时，即视为开发者已认真阅读服务条款全部内容，对服务条款均已知晓、理解并接受，同意将其作为确定双方权利义务的依据服务条款对开发者及本网站均具有法律效力，此后，开发者不得以未阅读本协议内容作任何形式的抗辩。</p>
      <br>
      <p>本网站是由江西三端科技有限公司运营和管理的为开发者（包括企业及个人）提供API申请、API调用、技术支持等多项服务的资源开放平台。</p><br>
      <span>1、定义</span>
      <p>1.1 开发者：指有效申请并经本网站审核同意后，有权使用本网站的接口的付费用户，包括法人、其他组织或自然人。</p>
      <p>1.2 资源开放平台：三端科技为开发者提供“九科星资源开放平台”的资源和技术服务，资源包括题库资源、资料库资源。</p>
      <span>2、服务对象</span>
      <p>2.1 同时满足下列条件的，方可被认定为本网站用户：</p>
      <p>（1）同意本《协议》内容并接受其约束；</p>
      <p>（2）完成在本网站的注册程序并获得本网站账户和密码;</p>
      <p>2.2 本网站用户类型及实名认证</p>
    <p>  2.2.1用户类型：</p>
      <p>（1）企业开发者；</p>
      <p>（2）个人开发者；</p>
      <p>2.2.2 实名认证说明：</p>
      <p>（1）个人用户进行实名认证需按照本网站的要求提供包括但不限于个人基本信息以及本网站认为为向用户提供满足用户需求的服务所必需的其他信息；</p>
      <p>（2）企业用户进行实名认证需按照本网站的要求提供包括但不限于个营业执照正副本照片、从事与本网站合作业务或使用本网站服务所必需的资质许可（如需）、企业基本信息以及本网站认为必需的其他信息；</p>
      <p> 开发者应保证其向本网站提供的证件、信息等内容真实、准确、完整、及时、有效，因开发者提供的证件、信息等内容不满足真实、准确、完整、及时、有效条件而引致的各种损失或责任，均由开发者自行承担。</p>
      <p>开发者资料若有更新的，开发者应在30个工作日内予以更新，如本网站发现其不真实或不准确的，本网站有权暂停或终止向其提供本协议下服务,由此产生的一切法律责任由开发者自行承担。</p>
    <span>3、服务内容</span><br>
    <p>3.1 本网站数据服务说明</p>
    <p>开发者可以使用本网站提供的数据API，用于自身平台上的开发。另外根据数据的特性不同，不同数据具有不同的资费标准。详细如下：</p>
    <p>（1）开发者成功开通账户，即可获得一定量的免费API调用次数，具体内容请参见相应的接口文档页；</p>
    <p>（2）注册用户可通过网上缴费或线下签订纸质合同使用本网站数据资源；</p>
    <p>（3）不同数据具有不同的试用权限，请开发者关注所申请数据的试用权限，具体内容请参见相应的接口文档页；</p>
    <p>（4）若开发者恶意使用本网站API（本网站享有自主判断的权利）、未经本网站同意采集本网站数据或通过本网站平台作出侵犯本网站合法权益的其他行为的，本网站将停止服务，并视情形需要确定是否采取法律维权措施；</p>
    <p>（5）本网站有权根据市场运作、服务内容、发展规划等因素调整相应数据服务收费标准，并于本网站或相应的接口文档页进行公告，而无需单独通知用户。用户在购买相应的数据服务时，应关注最新服务收费标准；</p><br>
    <p>本网站数据平台为提高开发者用户体验、完善服务质量，将视需要合理使用本网站平台产生的开发者数据，但会按相关法律规定保护开发者的个人隐私数据。开发者注册成为本网站用户，即视为开发者已同意本网站数据平台对用户数据/信息进行合理使用。</p>
    <p>3.2 数据定制服务</p>
    <p>本网站提供的一般性服务无法满足用户的需求时，本网站愿意为开发者提供专属定制服务。开发者可联系我们客服，咨询定制服务相关信息并另外签订纸质合同。</p>
    <span>4、服务内容的变更、中断和结束</span><br>
    <p>（1）本网站致力于为开发者提供更优质更稳定的服务，因此本网站可能会在服务期间对平台进行优化升级。本网站进行优化升级之前，将会在平台相应位置进行公告，请开发者实时关注。因优化升级而暂时中断为开发者提供服务，不视为本网站违反服务条款，本网站不因此向开发者承担任何责任；</p>
    <p>（2）本网站将通过优化服务、技术升级等方式为开发者提供优质、稳定、持续的服务，但因不可抗力因素导致的服务中断或影响服务质量，开发者理解并豁免本网站与此相关的任何责任。不可抗力因素包括但不限于自然灾害、罢工、骚乱、物质短缺或定量配给、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故、计算机病毒或黑客攻击；</p>
    <p>（3）若开发者不再需要本网站数据服务，可向本网站邮件发出用户身份注销申请或联系我们客服，经本网站审议通过，双方终止协议关系，本网站将停止为开发者提供服务；</p>
    <p>（4）开发者需持续满足本网站规定的开发者条件，若开发者不再符合本网站的开发者要求，本网站有权作出终止服务、注销开发者账户的决定。开发者对此有任何异议，可向本网站提出异议申请；</p>
    <p>（5）除遵守服务条款外，开发者在使用本网站服务时，还应遵守《九科星资源开放平台开发者服务协议》项下义务，否则本网站有权中断服务，或者拒绝用户的数据服务申请；</p>
    <p>（6）开发者应持续遵守服务条款。</p>
    <span>5、用户的帐号，密码及管理</span><br>
    <p>（1）在完成本网站用户的注册程序后，开发者将获得一个本网站账户，该账户密码由开发者设置并保管，本网站无法获悉。开发者有权通过本网站用户中心管理其账户，包括但不限于补充、更新用户信息，修改密码等，开发者应妥善保管账户信息及密码；</p>
    <p>（2）开发者应当遵守法律法规、规章、规范性文件及政策要求，谨慎合理使用和妥善保管本网站账号及密码，对通过账号和密码进行的行为和发生的事件负责。当开发者发现账号被未经其授权的第三方使用或存在其他账号安全问题时应立即有效通知本网站，要求本网站暂停该账号的服务。本网站有权在合理时间内对用户的该等请求采取行动，配合用户作出相应处理措施，但对开发者遭受的损失不承担任何责任。开发者不得将账号以赠与、借用、租用、转让或其他方式处分给他人；</p>
    <p>（3）为更好的为开发者提供服务，维护开发者合法权益，本网站将采取有效措施保护开发者的账户信息。若开发者在使用账户时发现安全漏洞，请立即以有效方式通知本网站。本网站将全力完善账户维护，但无法保证所采取的措施都是有效和安全无虞的，用户知晓、理解并豁免本网站因此产生的责任；</p>
    <p>（4）如本协议服务终止，本网站有权保留或删除开发者账号中的任何信息，也可不将该信息发还给开发者，也有权保存或删除开发者的全部相关数据。</p>
    <span>6、用户义务</span><br>
    <p>（1）开发者应当通过本网站注册成为本网站用户，其行为受本协议及本网站规则约束。开发者通过本网站接口使用到的资源仅限于开发者平台使用，不得未经本网站授权将获取的教育资源通过任何方式泄露、转交给第三方机构用作任何盈利或非盈利的用途。开发者不得违反本协议宗旨将开发者账户用于其他目的。如因开发者违反本协议及本网站相关管理规则，本网站将有权禁用该开发者账户或停止接口服务，未经本网站同意该开发者不得再次使用本网站资源服务；</p>
    <p>（2）开发者未经本网站授权不得以任何形式将本网站数据提供给任何他人使用；</p>
    <p>（3）开发者拥有依照本协议约定合法的使用资源开放平台API的权利，开发者不得向任何企业或个人出售转让转授权本网站的代码、API及开发工具等；</p>
    <p>（4）开发者不得以任何方式干扰或企图干扰本网站任何服务、功能的正常运行；</p>
    <p>（5）开发者不得为任何最终用户自动登录到本网站提供代理身份验证凭据；</p>
    <p>（6）开发者违反本网站使用规则时，本网站有权认识判断决定并采取以下行动，包括但不限于：限制、封闭开发者账号，终止与开发者的服务协议关系，以及其他本网站认为适合的处理方式；</p>
    <p>（7）一旦开发者接受本条款，开发者保证已达法定年龄且具有完全之行为能力，如果开发者代表一个公司，组织或其他法律实体，开发者保证公司或组织是根据居住地之法律所成立且持续有效的法律实体，开发者并保证公司或组织已合法授权开发者代表个人的公司或组织加入注册成为资源开放平台的使用者；</p>
    <p>（8）开发者同意接收来自三端科技发出的邮件、信息，包括但不限于关于用户利益、商业推广的信息等。</p>
    <span>7、免责事由</span><br>
    <p>7.1 如发生下述任一情况而导致服务中断及开发者损失的，本网站不承担责任： </p>
    <p>（1）发生不可抗力情形的；</p>
    <p>（2）黑客攻击、计算机病毒侵入或发作的；</p>
    <p>（3）计算机系统遭到破坏、瘫痪或无法正常使用的；</p>
    <p>（4）电信部门技术调整的；</p>
    <p>（5）因政府管制而造成暂时性关闭的；</p>
    <p>（6）其它非因三端科技的过错而引起的。</p>
    <span>8、服务条款的变更</span><br><br>
    <p>本网站有权视需要对服务条款内容作出补充、删除或变更（以下统称“服务条款变更”），并在本网站相应位置进行公布，而无需另行通知用户。若开发者不接受服务条款变更，可随时停止使用本网站提供的服务。 若开发者在服务条款变更公示后仍继续使用本网站提供的服务，则视为开发者已经阅读并接受服务条款变更，并愿意受变更后服务条款的约束。</p>
    <br>
    <p>如开发者书面通知平台不接受经本网站修改的新的服务协议的，本网站有权随时暂停或终止向其提供本协议下服务。</p>
    <span>9、知识产权条款</span><br><br>
    <p>三端科技拥有九科星资源开放平台上所有内容资源的知识产权，本网站所提供的一切资源内容，包括但不限于文字、图片、音像、图表、标志、标识、商标、软件、程序、版面设计、知识目录与名称、内容分类标准以及为开发者提供的任何信息，均受《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国专利法》等法律法规以及有关国际条约的保护，相应权利由江西三端科技有限公司及/或相关权利人享有。未经江西三端科技有限公司及/或相关权利人书面授权，不得将本站所提供的内容及相关服务用于商业性目的。</p>
    <span>10、本协议的解释、法律适用及争端解决</span><br>
    <p>10.1 三端科技对本协议条款拥有解释权。</p>
    <p>10.2 本协议的有效性、履行和与本协议及其修订本效力有关的所有事宜，将受中华人民共和国大陆法律管辖，任何争议仅适用中华人民共和国大陆法律。</p>
    <span>11、其他规定</span><br>
    <p>11.1 如本《协议》中的任何条款无论因何种原因完全或部分无效或不具有执行力，本《协议》的其余条款仍应有效并且有约束力；</p>
    <p>11.2 本《协议》中的标题仅为方便阅读而设，不应影响对本《协议》条款的理解。</p>
    <span>12、意见及建议</span><br><br>
    <p>用户对本网站服务有任何意见或建议，可向本网站内的邮箱反馈，本网站愿意倾听并尊重每一位开发者的意见，并将尽力为开发者提供最优质的服务。</p>
    `
  },
  'stageList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '学段列表接口'],
    title: '学段列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '400px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取所有学段', url: '/api/v1/invoke/invoke/stages', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '学段id' },
        { paras: 'name', type: 'String', description: '学段名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 2,
                "name": "小学"
            },
            {
                "id": 3,
                "name": "初中"
            },
            {
                "id": 4,
                "name": "高中"
            }
        ]
      }
    `
  },
  'subjectList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '科目列表接口'],
    title: '科目列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取一个学段下的所有科目', url: '/api/v1/invoke/invoke/stage/{stageId}/subjects', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '学科id' },
        { paras: 'name', type: 'String', description: '学科名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [{
            "id": 1,
            "name": "小学语文"
          },
          {
            "id": 2,
            "name": "小学数学"
          },
          {
            "id": 3,
            "name": "小学英语"
          }
        ]
      }
    `
  },
  'versionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '教材版本列表接口'],
    title: '教材版本列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取一个学科下的所有教材版本', url: '/api/v1/invoke/subject/{sid}/versions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'sid', type: 'Int', required: '必填', description: '科目id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '版本id' },
        { paras: 'name', type: 'String', description: '版本名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [{
            "id": 522,
            "name": "人教版（2001）"
          },
          {
            "id": 539,
            "name": "人教版（部编）（2016）"
          },
          {
            "id": 523,
            "name": "北师大版（2001）"
          }
        ]
      }
    `
  },
  'volumeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '教材册别列表接口'],
    title: '教材册别列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取一个版本下的所有册别', url: '/api/v1/invoke/version/{versionId}/textbooks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'versionId', type: 'Int', required: '必填', description: '版本id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '册别id' },
        { paras: 'name', type: 'String', description: '册别名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 141,
                "name": "七年级上册"
            },
            {
                "id": 142,
                "name": "七年级下册"
            },
            {
                "id": 143,
                "name": "八年级上册"
            },
            {
                "id": 144,
                "name": "八年级下册"
            }
        ]
      }
    `
  },
  'sectionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '教材章节列表接口'],
    title: '教材章节列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取一个册别下的所有章节', url: '/api/v1/invoke/textbook/{textbookId}/book-nodes', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '章节id' },
        { paras: 'name', type: 'String', description: '章节名称' },
        { paras: 'pathIds', type: 'String', description: '路径id字符串' },
        { paras: 'textbookId', type: 'Int', description: '册别id' },
        { paras: 'children', type: 'Object', description: '子集合' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 70740,
                "name": "识字 1",
                "pathIds": "70740",
                "textbookId": 2600,
                "children": [
                    {
                        "id": 70744,
                        "name": "1 秋天的图画",
                        "pathIds": "70740,70744",
                        "textbookId": 2600,
                        "children": []
                    },
                ]

            },
            {
                "id": 70756,
                "name": "识字 2",
                "pathIds": "70756",
                "textbookId": 2600,
                "children": [
                    {
                        "id": 70761,
                        "name": "5 一株紫丁香",
                        "pathIds": "70756,70761",
                        "textbookId": 2600,
                        "children": []
                    }
                ]
            }
        ]
      }
    `
  },
  'knowledgeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '知识点列表接口'],
    title: '知识点列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取一个学科下的所有知识点', url: '/api/v1/invoke/subject/{subjectId}/knowledge-points', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '知识点id' },
        { paras: 'name', type: 'String', description: '知识点名称' },
        { paras: 'pathIds', type: 'String', description: '知识点id字符串' },
        { paras: 'subjectId', type: 'Int', description: '学科id' },
        { paras: 'children', type: 'Object', description: '子集合' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 65654,
                "name": "字母",
                "pathIds": "65654",
                "subjectId": 3,
                "children": [
                    {
                        "id": 65655,
                        "name": "字母书写",
                        "pathIds": "65654,65655",
                        "subjectId": 3,
                        "children": []
                    }
                ]
            },
            {
                "id": 65658,
                "name": "语音",
                "pathIds": "65658",
                "subjectId": 3,
                "children": [
                    {
                        "id": 65659,
                        "name": "字母的发音",
                        "pathIds": "65658,65659",
                        "subjectId": 3,
                        "children": []
                    },
                    {
                        "id": 65660,
                        "name": "常见字母组合的发音",
                        "pathIds": "65658,65660",
                        "subjectId": 3,
                        "children": []
                    },
                    {
                        "id": 65661,
                        "name": "语调",
                        "pathIds": "65658,65661",
                        "subjectId": 3,
                        "children": []
                    }
                ]
            }
        ]
      }
    `
  },
  'questionTypeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '试题类型列表接口'],
    title: '试题类型列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取一个学科下的所有试题类型', url: '/api/v1/invoke/subject/{subjectId}/question-types', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题类型id' },
        { paras: 'name', type: 'String', description: '试题名称' },
        { paras: 'data', type: 'Object', description: '请求结果数据' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 1015,
                "name": "问答题",
                "isSelectType": false
            },
            {
                "id": 1014,
                "name": "翻译",
                "isSelectType": false
            }
        ]
      }
    `
  },
  'examTypeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '试卷类型列表接口'],
    title: '试卷类型列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取一个学科下的所有试卷类型', url: '/api/v1/invoke/subject/{subjectId}/exam/type', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试卷类型id' },
        { paras: 'name', type: 'String', description: '名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 1,
                "name": "课时练习"
            },
            {
                "id": 2,
                "name": "单元测试"
            },
            {
                "id": 3,
                "name": "月考"
            },
            {
                "id": 4,
                "name": "期中"
            }
        ]
      }
    `
  },
  'questionDifficult': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '试题难度列表接口'],
    title: '试题难度列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取所有试题难度', url: '/api/v1/invoke/question/difficult', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题难度id' },
        { paras: 'name', type: 'String', description: '名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 1,
                "name": "容易"
            },
            {
                "id": 2,
                "name": "较易"
            }
        ]
      }
    `
  },
  'provinceList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '省份列表接口'],
    title: '省份列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取所有省份', url: '/api/v1/invoke/province', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'name', type: 'String', description: '名称' },
        { paras: 'parentId', type: 'Int', description: '父级id' },
        { paras: 'level', type: 'Int', description: '层级' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 110000,
                "name": "北京",
                "parentId": 1,
                "level": 1
            },
            {
                "id": 120000,
                "name": "天津",
                "parentId": 1,
                "level": 1
            }
        ]
      }
    `
  },
  'gradeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '年级列表接口'],
    title: '年级列表接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '根据学段id获取年级列表', url: '/api/v1/invoke/stage/{stageId}/grade', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '年级id' },
        { paras: 'name', type: 'String', description: '名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 7,
                "name": "七年级"
            },
            {
                "id": 8,
                "name": "八年级"
            },
            {
                "id": 9,
                "name": "九年级"
            }
        ]
      }
    `
  },
  'docTypeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '文档类型接口'],
    title: '文档类型接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档列表', url: '/api/v1/invoke/document/type', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'name', type: 'String', description: '名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 1,
                "name": "课件"
            },
            {
                "id": 2,
                "name": "教案"
            },
            {
                "id": 3,
                "name": "习题/作业"
            },
            {
                "id": 4,
                "name": "学案/导学案"
            },
            {
                "id": 5,
                "name": "素材"
            },
            {
                "id": 6,
                "name": "视频"
            },
            {
                "id": 7,
                "name": "备课综合"
            }
        ]
      }
    `
  },
  'docColumnList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '文档栏目接口'],
    title: '文档栏目接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档栏目列表', url: '/api/v1/invoke/column/{stageId}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'name', type: 'String', description: '名称' },
        { paras: 'columnType', type: 'String', description: '文档栏目大类' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
          {
            "id": 6,
            "name": "同步资源",
            "columnType": 1
          }, {
            "id": 7,
            "name": "试卷中心",
            "columnType": 2
          }, {
            "id": 8,
            "name": "一轮复习",
            "columnType": 3
          }, {
            "id": 9,
            "name": "二轮复习",
            "columnType": 4
          }
        ]
      }
    `
  },
  'booknodeExam': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '通过单元章节获取普通试题接口'],
    title: '通过单元章节获取普通试题接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '通过单元章节获取普通试题', url: '/api/v1/invoke/questions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'booknode' },
        { paras: 'keyword', type: 'String', required: '选填', description: '题干关键字' },
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '可选', description: '章节id' },
        { paras: 'questionTypeId', type: 'Int', required: '可选', description: '试题类型id' },
        { paras: 'questionDifficultId', type: 'Int', required: '可选', description: '试题难度id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'year', type: 'String', required: '必填', description: '最小年份' },
        { paras: 'orderby', type: 'Number', required: '可选', description: '排序字段，updateTime-按更新时间排序，viewNum-按浏览次数排序，collectNum-按收藏次数排序，downloadNum-按下载次数排序' },
        { paras: 'direction', type: 'Number', required: '可选', description: '排序字段，默认asc 正序-asc，倒序-desc' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "content": [
              {
                  "id": 20502486,
                  "stem": "<p class=\"a DocDefaults \">中国近代史上，织。他们打着“扶清灭洋”的旗号，以反洋教为共同目标。他们是（　　）</span></span></p>",
                  "options": null,
                  "difficult": {
                      "id": 1,
                      "name": "容易"
                  },
                  "type": {
                      "id": 340107,
                      "name": "听力题",
                      "isSelectType": false
                  },
                  "updateTime": "2020-04-14T10:42:04.431",
                  "children": [],
                  "isCollection": null,
                  "zuJuanCount": 0,
                  "origin": 0
              }
          "totalPages": 171,
          "last": false,
          "totalElements": 1709,
          "number": 0,
          "size": 10,
          "first": true,
          "sort": {
              "sorted": true,
              "unsorted": false
          },
          "numberOfElements": 10
      }
  }
    `
  },
  'knowledgeExam': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '通过知识点获取普通试题接口'],
    title: '通过知识点获取普通试题接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '通过知识点获取普通试题接口', url: '/api/v1/invoke/questions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'knowledgePoint' },
        { paras: 'keyword', type: 'String', required: '选填', description: '题干关键字' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'knowledgePointId', type: 'Int', required: '可选', description: '知识点id' },
        { paras: 'questionTypeId', type: 'Int', required: '可选', description: '试题类型id' },
        { paras: 'questionDifficultId', type: 'Int', required: '可选', description: '试题难度id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'year', type: 'String', required: '必填', description: '最小年份' },
        { paras: 'orderby', type: 'Number', required: '可选', description: '排序字段，updateTime-按更新时间排序，viewNum-按浏览次数排序，collectNum-按收藏次数排序，downloadNum-按下载次数排序' },
        { paras: 'direction', type: 'Number', required: '可选', description: '排序字段，默认asc 正序-asc，倒序-desc' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "content": [
              {
                  "id": 231957,
                  "stem": "组词。 \n<br>控 \n<input type=\"text\" placeholder=\"1\" ms-duplex-string=\"question.myanswer[1]\" class=\"cke_questions_blankInput\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;挖 \n<input type=\"text\" placeholder=\"2\" ms-duplex-string=\"question.myanswer[2]\" class=\"cke_questions_blankInput\">&nbsp;&nbsp;&nbsp;改 \n<input type=\"text\" placeholder=\"3\" ms-duplex-string=\"question.myanswer[3]\" class=\"cke_questions_blankInput\">&nbsp;&nbsp;&nbsp;&nbsp;攻 \n<input type=\"text\" placeholder=\"4\" ms-duplex-string=\"question.myanswer[4]\" class=\"cke_questions_blankInput\"> \n<br>核 \n<input type=\"text\" placeholder=\"5\" ms-duplex-string=\"question.myanswer[5]\" class=\"cke_questions_blankInput\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;该 \n<input type=\"text\" placeholder=\"6\" ms-duplex-string=\"question.myanswer[6]\" class=\"cke_questions_blankInput\">&nbsp;&nbsp; 联 \n<input type=\"text\" placeholder=\"7\" ms-duplex-string=\"question.myanswer[7]\" class=\"cke_questions_blankInput\">&nbsp;&nbsp;&nbsp;&nbsp;耿 \n<input type=\"text\" placeholder=\"8\" ms-duplex-string=\"question.myanswer[8]\" class=\"cke_questions_blankInput\">",
                  "options": null,
                  "difficult": {
                      "id": 1,
                      "name": "容易"
                  },
                  "type": {
                      "id": 102,
                      "name": "填空题",
                      "isSelectType": false
                  },
                  "updateTime": "2016-09-09T10:24:07",
                  "children": [],
                  "isCollection": null,
                  "zuJuanCount": 0,
                  "origin": 0
              }
          ],
          "pageable": {
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "offset": 1,
              "pageSize": 1,
              "pageNumber": 1,
              "unpaged": false,
              "paged": true
          },
          "totalPages": 31182,
          "last": false,
          "totalElements": 31182,
          "number": 1,
          "size": 1,
          "first": false,
          "sort": {
              "sorted": true,
              "unsorted": false
          },
          "numberOfElements": 1
      }
  }
    `
  },
  'singleExam': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '获取普通单试题答案或解析接口'],
    title: '获取普通单试题答案或解析接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取单个试题答案和解析接口', url: '/api/v1/invoke/question/{questionId}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'questionId', type: 'Int', required: '必填', description: '试题id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目困难系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'answer', type: 'String', description: '答案' },
        { paras: 'labelAnswer', type: 'String', description: '去标签答案' },
        { paras: 'analysis', type: 'String', description: '解析' },
        { paras: 'children', type: 'Object', description: '子集合' },
        { paras: 'bookNodes', type: 'Object', description: '章节集合' },
        { paras: 'knowlegePoints', type: 'Object', description: '知识点集合' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "id": 15,
          "stem": "2013年12月，“玉 \n<a data-cke-saved-href=\"http://www.21cnjy.com\" href=\"http://www.21cnjy.com\">兔”号月球车</a>由运载火箭送入太空，成功登月。月球车质量为140千克，利用太阳能和核能工作，采用6个宽大且表面粗糙的筛网轮，具有多项现代科技成果。以下说法中错误的是&nbsp;&nbsp;&nbsp;&nbsp;(&nbsp;&nbsp;&nbsp;&nbsp;）",
          "options": {
              "A": "月球车在月球上重1400牛顿",
              "B": "火箭发射时，受到燃气对它的推力",
              "C": "采用6个宽大表面的筛网轮，可以减小月球车对月球表面的压强",
              "D": "太阳能电板能将太阳能转化成电能"
          },
          "difficult": {
              "id": 3,
              "name": "一般"
          },
          "type": {
              "id": 1901,
              "name": "选择题",
              "isSelectType": true
          },
          "updateTime": "2016-02-19T08:52:40",
          "answer": "A",
          "labelAnswer": "A",
          "analysis": "【分析】A．月球附近的重力比地球附近的重力小 \n<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; B．力的作用是相互的，只要一个物体对另一个物体施加了力，受力物体反过来也肯定会给施力物体增加一个力。 \n<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; C．压力一定时，受力面积越大，则压强越小 \n<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; D．太阳能电池能利用太阳能，将其转变为电能 \n<br>【解答】A．月球车在地球上重1400牛顿，月球的吸引力是地球1&nbsp;6，所以“月球车”在月球上重为233N，故A错误； \n<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; B．在火箭升空时，燃料经过燃烧产生气体，气体被排出时，受到火箭向下的力，根据力作用的相互性，气体对火箭有一个向上的推力，故B正确； \n<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; C．6只宽大的车轮，可以增大与月面的接触面积，从而减小“玉兔号”对月面的压强，故C正确； \n<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; D．太阳能电池是把太阳能转化为电能的装置，故D正确。",
          "children": [],
          "bookNodes": [
              {
                  "id": 45061,
                  "name": "2  力",
                  "pathIds": "45059,45061",
                  "textbookId": 2369
              },
              {
                  "id": 45062,
                  "name": "3  几种常见的力",
                  "pathIds": "45059,45062",
                  "textbookId": 2369
              },
              {
                  "id": 45812,
                  "name": "力与空间探索",
                  "pathIds": "45807,45812",
                  "textbookId": 2349
              },
              {
                  "id": 46124,
                  "name": "第2节  力的存在",
                  "pathIds": "46122,46124",
                  "textbookId": 2355
              },
              {
                  "id": 46125,
                  "name": "第3节  重力",
                  "pathIds": "46122,46125",
                  "textbookId": 2355
              },
              {
                  "id": 46128,
                  "name": "第6节  摩擦力",
                  "pathIds": "46122,46128",
                  "textbookId": 2355
              },
              {
                  "id": 46237,
                  "name": "第8节  能量的转化与守恒",
                  "pathIds": "46229,46237",
                  "textbookId": 2358
              },
              {
                  "id": 52522,
                  "name": "能的转化",
                  "pathIds": "52518,52522",
                  "textbookId": 2347
              }
          ],
          "knowledgePoints": [
              {
                  "id": 56343,
                  "name": "力的作用是相互的",
                  "pathIds": "56314,56337,56338,56343",
                  "subjectId": 19
              },
              {
                  "id": 56358,
                  "name": "重力的大小",
                  "pathIds": "56314,56337,56338,56358",
                  "subjectId": 19
              },
              {
                  "id": 56361,
                  "name": "增大或减小摩擦的方法",
                  "pathIds": "56314,56337,56338,56361",
                  "subjectId": 19
              },
              {
                  "id": 56576,
                  "name": "能量的相互转化和转移",
                  "pathIds": "56314,56536,56572,56576",
                  "subjectId": 19
              }
          ]
      }
  }
    `
  },
  'getExamIds': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '试题id集合'],
    title: '试题id集合', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '280px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '根据章节知识点和试题类型获取试题id集合接口', url: '/api/v1/invoke/question/ids', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'questionTypeId', type: 'Int', required: '选填', description: '试题类型id' },
        { paras: 'textbookId', type: 'Int', required: '选填', description: '册别id' },
        { paras: 'booknodeId', type: 'Int', required: '选填', description: '章节id' },
        { paras: 'subjectId', type: 'Int', required: '选填', description: '学科id' },
        { paras: 'knowledgePointIds', type: 'String', required: '选填', description: '知识点id' }
      ]
    },
    showResponseTable: false, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'code',
          type: 'Int',
          description: '错误码： 1：表示正常；不等于1表示不正常，查看msg 信息' },
        { paras: 'msg', type: 'String', description: '请求结果' },
        { paras: 'data', type: 'Object', description: '请求结果数据' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            19670205,
            19669300,
            19662268,
            19675960,
            19675965,
            19681818,
            19680394
        ]
      }
    `
  },
  'getExamLists': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '试题列表集合'],
    title: '试题列表集合', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '根据试题id获取试题列表接口', url: '/api/v1/invoke/ids/question', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'questionIds', type: 'Int', required: '必填', description: '试题id集合' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目困难系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'answer', type: 'String', description: '答案' },
        { paras: 'labelAnswer', type: 'String', description: '去标签答案' },
        { paras: 'analysis', type: 'String', description: '解析' },
        { paras: 'children', type: 'Object', description: '子集合' },
        { paras: 'bookNodes', type: 'Object', description: '章节集合' },
        { paras: 'knowlegePoints', type: 'Object', description: '知识点集合' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
          {
              "id": 19670205,
              "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: Times New Roman;\" >（2018</span><span style=\"font-size: 14px;font-family: 宋体;\" >高密市一模）如图是某导航卫星的轨道示意图，已知该卫星沿椭圆轨道绕地球运行的过程中机械能守恒，该卫星从远地点向近地点运行过程中势能、动能、速度的变化是</span></p><p style='line-height: 24px;text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/6/12/1965684226547712/1967531424858113/STEM/9050479fc815429fa3a155307a9cb49a.png\" width=\"95\" height=\"103\" /></p>",
              "options": {
                  "A": "<span style=\"font-size: 14px;font-family: 宋体;\" >势能增加、动能减小、速度减小</span>",
                  "B": "<span style=\"font-size: 14px;font-family: 宋体;\" >势能不变、动能不变、速度不变</span>",
                  "C": "<span style=\"font-size: 14px;font-family: 宋体;\" >势能减小、动能增加、速度不变</span>",
                  "D": "<span style=\"font-size: 14px;font-family: 宋体;\" >势能减小、动能增加、速度增加</span>"
              },
              "difficult": {
                  "id": 4,
                  "name": "较难"
              },
              "type": {
                  "id": 1301,
                  "name": "选择题",
                  "isSelectType": true
              },
              "updateTime": "2018-09-06T05:11:20",
              "children": [],
              "isCollection": null,
              "zuJuanCount": 0,
              "origin": 0
          }
      ]
  }
    `
  },
  'getExamListsByChapter': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '根据章节获取精品试题列表'],
    title: '根据章节获取精品试题列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '根据章节获取精品试题列表', url: '/api/v1/invoke/excellent-questions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'booknode' },
        { paras: 'keyword', type: 'String', required: '选填', description: '题干关键字' },
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '可选', description: '章节id' },
        { paras: 'questionTypeId', type: 'Int', required: '可选', description: '试题类型id' },
        { paras: 'questionDifficultId', type: 'Int', required: '可选', description: '试题难度id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'year', type: 'String', required: '选填', description: '最小年份' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '题目难度系数' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "content": [
              {
                  "id": 20503848,
                  "stem": "<p class=\"1 a DocDefaults \"><span class=\"a0 \" style=\"font-style: italic;\"><span class=\"\" style=\"\">在等比数列{</span></span><span class=\"a0 \" style=\"font-style: italic;;font-family: 'Times New Roman';\">a</span><sub>n</sub><span class=\"a0 \" style=\"font-style: italic;\"><span class=\"\" style=\"\">}中</span></span><span class=\"\" style=\"\">，</span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">a<sub>1</sub><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">a<sub>7</sub><span class=\"\" style=\"\">=16，</span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">a<sub>5</sub><span class=\"\" style=\"\">=8，则数列{</span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">a<sub>n</sub><span class=\"\" style=\"\">}的公比为(　　)</span></p>",
                  "options": {
                      "A": "4　　　　　　　　</span></p><p class=\"1 a DocDefaults \">",
                      "B": "±4</span></p><p class=\"1 a DocDefaults \">",
                      "C": "2</span></p><p class=\"1 a DocDefaults \">",
                      "D": "±2</span></p>"
                  },
                  "difficult": {
                      "id": 1,
                      "name": "容易"
                  },
                  "type": {
                      "id": 2614,
                      "name": "单选题",
                      "isSelectType": true
                  },
                  "updateTime": "2020-05-14T16:52:05",
                  "children": [],
                  "isCollection": null,
                  "zuJuanCount": 11,
                  "origin": 1
              }
          ],
          "pageable": {
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "offset": 1,
              "pageSize": 1,
              "pageNumber": 1,
              "unpaged": false,
              "paged": true
          },
          "totalElements": 217,
          "totalPages": 217,
          "last": false,
          "number": 1,
          "size": 1,
          "first": false,
          "sort": {
              "sorted": true,
              "unsorted": false
          },
          "numberOfElements": 1
      }
  }
    `
  },
  'getExamListsByKnow': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '根据知识点获取精品试题列表'],
    title: '根据知识点获取精品试题列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '根据知识点获取精品试题列表', url: '/api/v1/invoke/excellent-questions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'knowledgePoint' },
        { paras: 'keyword', type: 'String', required: '选填', description: '题干关键字' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'knowledgePointId', type: 'Int', required: '可选', description: '知识点id' },
        { paras: 'questionTypeId', type: 'Int', required: '可选', description: '试题类型id' },
        { paras: 'questionDifficultId', type: 'Int', required: '可选', description: '试题难度id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'year', type: 'String', required: '选填', description: '最小年份' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '题目难度系数' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": {
              "content": [
                  {
                      "id": 186905872,
                      "stem": "<p class=\"a DocDefaults \" style=\"position: relative; margin-left: 0.15in;text-indent: -0.15in;line-height: 208%;\"></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">2</span><span class=\"a0 \" style=\"font-family: 'SimSun';\">.</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">我国传统医学认为，七情过度会影响脏腑功能的协调而致病，如</span><span class=\"\" style=\"font-family: 'SimSun';\">“</span><span class=\"\" style=\"font-family: 'Times New Roman';\">喜伤心</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">,怒伤肝,</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">思伤牌，忧伤肺，恐伤肾</span><span class=\"\" style=\"font-family: 'SimSun';\">”</span><span class=\"\" style=\"font-family: 'Times New Roman';\">。</span></span><span class=\"a0 \" style=\"font-family: 'PMingLiU';\">这启示我们要</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'SimSun';\">（　　）</span></span></p>",
                      "options": {
                          "A": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">心如止水，</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">勿喜勿悲</span><span class=\"a0 \" style=\"\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>",
                          "B": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'PMingLiU';\">调控情绪，合理宣泄</span></span></p><p class=\"a DocDefaults \" style=\"position: relative; margin-left: 7mm;text-indent: -0.15in;line-height: 208%;\">",
                          "C": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'PMingLiU';\">战胜挫折，珍爱生命</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>",
                          "D": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'PMingLiU';\">拒绝诱惑，防止刺激</span></span></p>"
                      },
                      "difficult": {
                          "id": 3,
                          "name": "一般"
                      },
                      "type": {
                          "id": 1012,
                          "name": "单选题",
                          "isSelectType": true
                      },
                      "updateTime": "2020-06-02T08:42:23.76",
                      "children": [],
                      "isCollection": null,
                      "zuJuanCount": 0,
                                      "origin": 3
                  }
              ],
              "pageable": {
                  "sort": {
                      "sorted": true,
                      "unsorted": false
                  },
                  "offset": 1,
                  "pageSize": 1,
                  "pageNumber": 1,
                  "paged": true,
                  "unpaged": false
              },
              "totalPages": 8,
              "last": false,
              "totalElements": 8,
              "number": 1,
              "size": 1,
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "numberOfElements": 1,
              "first": false
          }
      }
    `
  },
  'getExamListsAnaysis': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '获取精品试题答案解析'],
    title: '获取精品试题答案解析', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取精品试题答案解析', url: '/api/v1/invoke/excellent-question/{questionId}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'questionId', type: 'Int', required: '必填', description: '题目id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目困难系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'answer', type: 'String', description: '答案' },
        { paras: 'labelAnswer', type: 'String', description: '去标签答案' },
        { paras: 'analysis', type: 'String', description: '解析' },
        { paras: 'children', type: 'Object', description: '子集合' },
        { paras: 'bookNodes', type: 'Object', description: '章节集合' },
        { paras: 'knowlegePoints', type: 'Object', description: '知识点集合' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "id": 186905872,
          "stem": "<p class=\"a DocDefaults \" style=\"position: relative; margin-left: 0.15in;text-indent: -0.15in;line-height: 208%;\"></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">2</span><span class=\"a0 \" style=\"font-family: 'SimSun';\">.</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">我国传统医学认为，七情过度会影响脏腑功能的协调而致病，如</span><span class=\"\" style=\"font-family: 'SimSun';\">“</span><span class=\"\" style=\"font-family: 'Times New Roman';\">喜伤心</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">,怒伤肝,</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">思伤牌，忧伤肺，恐伤肾</span><span class=\"\" style=\"font-family: 'SimSun';\">”</span><span class=\"\" style=\"font-family: 'Times New Roman';\">。</span></span><span class=\"a0 \" style=\"font-family: 'PMingLiU';\">这启示我们要</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'SimSun';\">（　　）</span></span></p>",
          "options": {
              "A": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">心如止水，</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">勿喜勿悲</span><span class=\"a0 \" style=\"\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>",
              "B": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'PMingLiU';\">调控情绪，合理宣泄</span></span></p><p class=\"a DocDefaults \" style=\"position: relative; margin-left: 7mm;text-indent: -0.15in;line-height: 208%;\">",
              "C": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'PMingLiU';\">战胜挫折，珍爱生命</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>",
              "D": "</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'PMingLiU';\">拒绝诱惑，防止刺激</span></span></p>"
          },
          "difficult": {
              "id": 3,
              "name": "一般"
          },
          "type": {
              "id": 1012,
              "name": "单选题",
              "isSelectType": true
          },
          "updateTime": "2020-06-02T08:42:23.76",
          "answer": "B",
          "labelAnswer": "B",
          "analysis": "<p class=\"a DocDefaults \" style=\"line-height: 183%;\">抓住题干材料</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">中的</span><span class=\"\" style=\"font-family: 'SimSun';\">“</span><span class=\"\" style=\"font-family: 'Times New Roman';\">七情过度会影响脏腑功能的协调而致病</span><span class=\"\" style=\"font-family: 'SimSun';\">”</span><span class=\"\" style=\"font-family: 'Times New Roman';\">这一关键语和</span><span class=\"\" style=\"font-family: 'SimSun';\">“</span><span class=\"\" style=\"font-family: 'Times New Roman';\">喜伤心，怒伤肝，思伤脾，优伤肺，恐伤肾</span><span class=\"\" style=\"font-family: 'SimSun';\">”</span><span class=\"\" style=\"font-family: 'Times New Roman';\">，可知启示我们应该学会调控自己的情绪，合理地宣泄不良情绪，以促进身心健康，而与战胜挫折拒绝诱惑均无直接的关联性，故排除</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">C、D</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">，而选择</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">B；A</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">的表述错在</span><span class=\"\" style=\"font-family: 'SimSun';\">“</span><span class=\"\" style=\"font-family: 'Times New Roman';\">勿喜勿悲</span><span class=\"\" style=\"font-family: 'SimSun';\">”</span><span class=\"\" style=\"font-family: 'Times New Roman';\">；同时</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">D</span><span class=\"a0 \" style=\"\"><span class=\"\" style=\"font-family: 'Times New Roman';\">的表述本身也错误，应该是拒绝不良诱惑；故正确答案为</span></span><span class=\"a0 \" style=\"font-family: 'Times New Roman';\">B。</span></p>",
          "children": [],
          "bookNodes": [],
          "knowledgePoints": [
              {
                  "id": 52391,
                  "name": "阅读与鉴赏",
                  "pathIds": "52391,",
                  "subjectId": 10
              }
          ]
      }
  }
    `
  },
  'getExamListsByUnitChapter': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '通过单元章节获取所有试题接口'],
    title: '通过单元章节获取所有试题接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '通过单元章节获取所有试题接口', url: '/api/v1/invoke/questions/all', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'booknode' },
        { paras: 'keyword', type: 'String', required: '选填', description: '题干关键字' },
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '可选', description: '章节id' },
        { paras: 'questionTypeId', type: 'Int', required: '可选', description: '试题类型id' },
        { paras: 'questionDifficultId', type: 'Int', required: '可选', description: '试题难度id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'year', type: 'String', required: '选填', description: '最小年份' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code":1,
          "msg":"成功",
          "data":{
              "content":[
                  {
                      "id":15870872,
                      "stem":"<p style=''>在成长的过程中，你会有许多的碡触、许多高兴的事，许多烦恼的事需要倾诉，下面请</p><p style=''>你以“——————我想对你说”为题，写一篇500宇以上的作文。</p>",
                      "options":null,
                      "difficult":{
                          "id":2,
                          "name":"较易"
                      },
                      "type":{
                          "id":1010,
                          "name":"作文",
                          "isSelectType":false
                      },
                      "updateTime":"2018-09-01T06:46:04",
                      "children":[

                      ],
                      "isCollection":null,
                      "zuJuanCount":59,
                      "origin":0
                  },
                  {
                      "id":16066657,
                      "stem":"<p style='line-height: 24px;'><span style="font-size: 14px;font-family: 宋体;" >下列各句中，没有语病的一句是（    ）</span></p>",
                      "options":{
                          "A":"<span >能否顺利开展大课间活动，也是提高学生身体素质的重要保障条件 。</span>",
                          "B":"<span >记者探访多家药店发现，部分药品价格上调 ，大多数药品价格保持稳定 。</span>",
                          "C":"<span >敦煌市承办首届丝路文賻会的各个展馆都在改善建设及改造的进度。</span>",
                          "D":"<span >吉利公司推出的首款电动车"知豆 DI"初步定价大约在 4 至6 万元左右。</span>"
                      },
                      "difficult":{
                          "id":3,
                          "name":"一般"
                      },
                      "type":{
                          "id":1001,
                          "name":"选择题",
                          "isSelectType":true
                      },
                      "updateTime":"2018-08-26T20:55:47",
                      "children":[

                      ],
                      "isCollection":null,
                      "zuJuanCount":38,
                      "origin":0
                  }
              ],
              "pageable":{
                  "sort":{
                      "sorted":true,
                      "unsorted":false
                  },
                  "pageSize":2,
                  "pageNumber":0,
                  "offset":0,
                  "paged":true,
                  "unpaged":false
              },
              "totalElements":104,
              "last":false,
              "totalPages":52,
              "first":true,
              "sort":{
                  "sorted":true,
                  "unsorted":false
              },
              "numberOfElements":2,
              "size":2,
              "number":0
          }
      }
    `
  },
  'getAllExamListsByKnow': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '通过知识点获取所有试题接口'],
    title: '通过知识点获取所有试题接口', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '通过知识点获取所有试题接口', url: '/api/v1/invoke/questions/all', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'knowledgePoint' },
        { paras: 'keyword', type: 'String', required: '选填', description: '题干关键字' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'knowledgePointId', type: 'Int', required: '可选', description: '知识点id' },
        { paras: 'questionTypeId', type: 'Int', required: '可选', description: '试题类型id' },
        { paras: 'questionDifficultId', type: 'Int', required: '可选', description: '试题难度id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'year', type: 'String', required: '选填', description: '最小年份' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code":1,
          "msg":"成功",
          "data":{
              "content":[
                  {
                      "id":3425,
                      "stem":"下列划线字的读音错误最多的一项是（    ）",
                      "options":{
                          "A":"佝偻（lǚ）        乘客（chèng）    眩晕（yūn）               势不可当（dǎng）",
                          "B":"寰宇（yuán）   俳优（fēi）          量体裁衣（liàng）     勖勉有加（xù）",
                          "C":"连累（lěi）       逾越（yú）          博闻强识（shí）         呱呱坠地（guā）",
                          "D":"顷刻（qǐng）    辟邪（pì）          嬖臣宠妾（pì）           怙恶不悛（gū）"
                      },
                      "difficult":{
                          "id":3,
                          "name":"一般"
                      },
                      "type":{
                          "id":2614,
                          "name":"单选题",
                          "isSelectType":true
                      },
                      "updateTime":"2015-12-10T23:06:58",
                      "children":[

                      ],
                      "isCollection":null,
                      "zuJuanCount":46,
                      "origin":0
                  },
                  {
                      "id":52484,
                      "stem":"下列各句中划线词的注音、解释都正确的一项是(  )",
                      "options":{
                          "A":"行李之往来，  <u>共</u>其乏困（gōng通“供”， 供给）",
                          "B":"樊於期  <u>偏袒</u>扼腕而进（piān tǎn袒护双方中的一方）",
                          "C":"厚  <u>遗</u>秦王宠臣中庶子蒙嘉（yí遗失）",
                          "D":"<u>卒</u>起不意，尽失其度 （zú通“猝”，突然）"
                      },
                      "difficult":{
                          "id":3,
                          "name":"一般"
                      },
                      "type":{
                          "id":2614,
                          "name":"单选题",
                          "isSelectType":true
                      },
                      "updateTime":"2015-11-27T22:36:39",
                      "children":[

                      ],
                      "isCollection":null,
                      "zuJuanCount":79,
                      "origin":0
                  }
              ],
              "pageable":{
                  "sort":{
                      "sorted":true,
                      "unsorted":false
                  },
                  "pageSize":2,
                  "pageNumber":0,
                  "offset":0,
                  "paged":true,
                  "unpaged":false
              },
              "totalElements":1310,
              "last":false,
              "totalPages":655,
              "first":true,
              "sort":{
                  "sorted":true,
                  "unsorted":false
              },
              "numberOfElements":2,
              "size":2,
              "number":0
          }
      }
    `
  },
  'getExamAnswerAndAnaysis': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试题接口', '获取试题答案解析'],
    title: '获取试题答案解析', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题答案解析', url: '/api/v1/invoke/question/{questionId}/resource/{origin}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'questionId', type: 'Int', required: '必填', description: '题目id' },
        { paras: 'origin', type: 'Int', required: '必填', description: '0:普通，非0:精品' },
        { paras: 'orderby', type: 'Number', required: '可选', description: '排序字段，updateTime-按更新时间排序，viewNum-按浏览次数排序，collectNum-按收藏次数排序，downloadNum-按下载次数排序' },
        { paras: 'direction', type: 'Number', required: '可选', description: '排序字段，默认asc 正序-asc，倒序-desc' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code":1,
          "msg":"成功",
          "data":{
              "id":186909034,
              "stem":"<p class="1 a DocDefaults ">在平面直角坐标系<span class="a0 " style="font-style: italic; ;font-family: 'Times New Roman';">xOy</span><span class="a0 ">中，已知四边形</span><span class="a0 " style="font-style: italic; ;font-family: 'Times New Roman';">ABCD</span><span class="a0 ">是平行四边形，</span> <math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       B      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">=(2</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">-3)</span><span class="a0 ">，</span> <math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       D      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">=(-1</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">2)</span><span class="a0 ">，则</span> <math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       B      </mi>      <mi>       D      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">·</span> <math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       C      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">=(</span><span class="a0 " style="font-style: italic; ;white-space: pre-wrap;">　　</span><span class="a0 " style="font-family: 'Times New Roman';">)</span></p>",
              "options":{
                  "A":"<p>-2</p>",
                  "B":"<p>2</p>",
                  "C":"<p>8</p>",
                  "D":"<p>-8</p>"
              },
              "difficult":{
                  "id":2,
                  "name":"较易"
              },
              "type":{
                  "id":2701,
                  "name":"单选题",
                  "isSelectType":true
              },
              "updateTime":"2020-05-14T09:50:22.286",
              "answer":"D",
              "labelAnswer":"D",
              "analysis":"<p class="1 a DocDefaults "><math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       B      </mi>      <mi>       D      </mi>     </mrow>     <mo>      →     </mo>    </mover>    <mo>     =    </mo>    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       D      </mi>     </mrow>     <mo>      →     </mo>    </mover>    <mo>     -    </mo>    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       B      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">=(-1</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">2)-(2</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">-3)=(-3</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">5)</span><span class="a0 ">，</span></p> <p class="1 a DocDefaults "><math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       C      </mi>     </mrow>     <mo>      →     </mo>    </mover>    <mo>     =    </mo>    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       D      </mi>     </mrow>     <mo>      →     </mo>    </mover>    <mo>     +    </mo>    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       B      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">=(-1</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">2)+(2</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">-3)=(1</span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">-1)</span><span class="a0 ">，</span></p> <p class="1 a DocDefaults "><math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       B      </mi>      <mi>       D      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">·</span> <math xmlns="http://www.w3.org/1998/Math/MathML">    <mover accent="true">     <mrow>      <mi>       A      </mi>      <mi>       C      </mi>     </mrow>     <mo>      →     </mo>    </mover>   </math><span class="a0 " style="font-family: 'Times New Roman';">=(-3</span><span class="a0 ">，</span><span class="a0 "><span class="" style="font-family: 'Times New Roman';">5)·(1</span></span><span class="a0 ">，</span><span class="a0 " style="font-family: 'Times New Roman';">-1)=-3-5=-8.</span></p>",
              "children":[

              ],
              "bookNodes":[
                  {
                      "id":217544,
                      "name":"6.3 平面向量基本定理及坐标表示",
                      "pathIds":"217536,217544,",
                      "textbookId":4905
                  },
                  {
                      "id":9441,
                      "name":"2.4.2 平面向量数量积的坐标表示、模、夹角",
                      "pathIds":"9425,9439,9441,",
                      "textbookId":1430
                  }
              ],
              "knowledgePoints":[
                  {
                      "id":11333,
                      "name":"平面向量数量积的运算",
                      "pathIds":"11267,11329,11333,",
                      "subjectId":27
                  },
                  {
                      "id":11340,
                      "name":"数量积的坐标表示",
                      "pathIds":"11267,11329,11339,11340,",
                      "subjectId":27
                  }
              ]
          }
      }
    `
  },
  'getPaperList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试卷接口', '获取试卷列表'],
    title: '获取试卷列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷列表', url: '/api/v1/invoke/exams', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'gradeId', type: 'Int', required: '可选', description: '学科id' },
        { paras: 'examTypeId', type: 'Int', required: '可选', description: '试卷类型id' },
        { paras: 'provinceId', type: 'Int', required: '可选', description: '省份id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试卷id' },
        { paras: 'name', type: 'String', description: '试卷名称' },
        { paras: 'subject', type: 'String', description: '学科' },
        { paras: 'grade', type: 'Object', description: '年级' },
        { paras: 'examType', type: 'Object', description: '考试类型' },
        { paras: 'year', type: 'String', description: '年份' },
        { paras: 'province', type: 'Object', description: '省份' },
        { paras: 'questionCount', type: 'boolean', description: '题目数量' },
        { paras: 'updatedTime', type: 'Int', description: '更新时间' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Int', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "content": [
              {
                  "id": 224237,
                  "name": "2013-2014学年湖北丹江口市习家店中学初一10月素质检测生物卷（带解析）",
                  "subject": "生物",
                  "grade": "七年级",
                  "examType": "月考",
                  "year": 2013,
                  "province": "湖北省",
                  "questionCount": 30,
                  "updatedTime": "2018-09-10 20:49:59"
              }
          ],
          "pageable": {
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "offset": 0,
              "pageSize": 5,
              "pageNumber": 0,
              "paged": true,
              "unpaged": false
          },
          "totalElements": 2,
          "totalPages": 1,
          "last": true,
          "number": 0,
          "size": 5,
          "first": true,
          "sort": {
              "sorted": true,
              "unsorted": false
          },
          "numberOfElements": 2
      }
  }
    `
  },
  'getPaperDetailByPaperId': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '试卷接口', '通过试卷id获取试卷详情'],
    title: '通过试卷id获取试卷详情', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '通过试卷id获取试卷详情', url: '/api/v1/invoke/questions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'paper' },
        { paras: 'paperId', type: 'Int', required: '必填', description: '试卷id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '困难点' },
        { paras: 'type', type: 'Object', description: '试题类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'List', description: '子题' },
        { paras: 'origin', type: 'Int', description: '是否是精品(0:普通，非0:精品)' }
      ]
    },
    keyIntroductErrorInfo: '注意：origin=0时表示普通试题，需要按照普通试题获取详情接口获取试题详情；origin !=0 需按照精品获取试题答案和解析接口获取相关答案和解析',
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": {
              "content": [
                  {
                      "id": 18658722,
                      "stem": "<p style=''><span style=\"\" >读(dú)一(yì) 读(dú)，连(lián) 一(yì) 连(lián)。</span><img  src=\"/2016/12/5/1579029873147904/1579029873278976/STEM/549140b354c5458ca416e21a80325dde.png\" /></p>",
                      "options": null,
                      "difficult": {
                          "id": 3,
                          "name": "一般"
                      },
                      "type": {
                          "id": 109,
                          "name": "连线题",
                          "isSelectType": false
                      },
                      "updateTime": "2018-08-31T01:57:59",
                      "children": [],
                      "isCollection": null,
                      "zuJuanCount": 82,
                      "origin": 0
                  }
              ],
              "pageable": {
                  "sort": {
                      "sorted": true,
                      "unsorted": false
                  },
                  "offset": 0,
                  "pageSize": 20,
                  "pageNumber": 0,
                  "paged": true,
                  "unpaged": false
              },
              "totalElements": 1,
              "last": true,
              "totalPages": 1,
              "number": 0,
              "size": 20,
              "first": true,
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "numberOfElements": 1
          }
      }
    `
  },
  'getDocumentList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '文档接口', '获取普通文档列表'],
    title: '获取普通文档列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取普通文档列表', url: '/api/v1/invoke/documents', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'booknode' },
        { paras: 'columnId', type: 'Int', required: '选填', description: '文档栏目id' },
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '选填', description: '章节id' },
        { paras: 'documentTypeId', type: 'Int', required: '选填', description: '文档类型id' },
        { paras: 'provinceId', type: 'Int', required: '选填', description: '省份id' },
        { paras: 'year', type: 'Int', required: '选填', description: '年份' },
        { paras: 'name', type: 'String', required: '选填', description: '文档名称关键字' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'orderby', type: 'Number', required: '可选', description: '排序字段，updateTime-按更新时间排序，viewNum-按浏览次数排序，collectNum-按收藏次数排序，downloadNum-按下载次数排序' },
        { paras: 'direction', type: 'Number', required: '可选', description: '排序字段，默认asc 正序-asc，倒序-desc' },
        { paras: 'versionId', type: 'Int', required: '可选', description: '版本id' }
      ]
    },
    YWRequestParamsErrorInfo: '注释：documentTypeId = 3 时,查询的是包含习题作业和试卷',
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'name', type: 'String', description: '名称' },
        { paras: 'suffixType', type: 'String', description: '文档后缀' },
        { paras: 'size', type: 'String', description: '文档大小' },
        { paras: 'updateTime', type: 'String', description: '文档更新时间' },
        { paras: 'downloadNum', type: 'Int', description: '文档下载次数' },
        { paras: 'documentType', type: 'Object', description: '文档类型' },
        { paras: 'province', type: 'String', description: '文档省份' },
        { paras: 'stage', type: 'Object', description: '文档所属学段' },
        { paras: 'subject', type: 'Object', description: '文档所属学科' },
        { paras: 'grade', type: 'Object', description: '文档所属年级' },
        { paras: 'version', type: 'Object', description: '文档所属版本' },
        { paras: 'totalPages', type: 'Int', description: '总页数' },
        { paras: 'totalElements', type: 'Int', description: '总数' },
        { paras: 'numberOfElements', type: 'Int', description: '每页显示条数' },
        { paras: 'sort', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": {
              "content": [
                  {
                      "id": 409266,
                      "name": "北师大高中历史必修一课件：第八单元第23课　两极对峙格局的形成（共11张PPT）",
                      "suffixType": "ppt",
                      "size": 666,
                      "updateTime": "2015-11-26",
                      "documentType": {
                          "id": 1,
                          "name": "课件"
                      },
                      "stage": {
                          "id": 4,
                          "name": "高中"
                      },
                      "grade": {
                          "id": 10,
                          "name": "高一"
                      },
                      "subject": {
                          "id": 33,
                          "name": "历史"
                      },
                      "version": {
                          "id": 373,
                          "name": "北师大版"
                      },
                      "downloadNum": 81,
                      "viewNum": 243,
                      "province": null,
                      "bookNodes": null
                  }
              ],
              "pageable": {
                  "sort": {
                      "sorted": true,
                      "unsorted": false
                  },
                  "offset": 0,
                  "pageSize": 20,
                  "pageNumber": 0,
                  "unpaged": false,
                  "paged": true
              },
              "totalElements": 545,
              "totalPages": 28,
              "last": false,
              "number": 0,
              "size": 20,
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "numberOfElements": 20,
              "first": true
          }
      }
    `
  },
  'getDocumentDetail': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '文档接口', '获取文档详情'],
    title: '获取文档详情', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档详情', url: '/api/v1/invoke/document/{documentId}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Number', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'code',
          type: 'Int',
          description: '错误码： 1：表示正常；不等于1表示不正常，查看msg 信息' },
        { paras: 'msg', type: 'String', description: '请求结果' },
        { paras: 'data', type: 'Object', description: '请求结果数据' }
      ]
    },
    showKeyIntroduct: true, // 显示字段解释
    keyIntroductTable: {
      tableHead: [{
        prop: 'paras',
        width: '283px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '283px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        width: '283px',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'name ', type: 'String', description: '名称' },
        { paras: 'suffixType ', type: 'String', description: '文档后缀' },
        { paras: 'size ', type: 'String', description: '文档大小' },
        { paras: 'updateTime ', type: 'String', description: '文档更新时间' },
        { paras: 'downloadNum ', type: 'Int', description: '文档下载次数' },
        { paras: 'documentType ', type: 'Object', description: '文档类型' },
        { paras: 'province ', type: 'String', description: '文档省份' },
        { paras: 'stage ', type: 'Object', description: '文档所属学段' },
        { paras: 'subject ', type: 'Object', description: '文档所属学科' },
        { paras: 'version ', type: 'Object', description: '文档所属版本' },
        { paras: 'bookNodes ', type: 'List', description: '文档关联章节列表' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "id": 411734,
          "name": "[中学联盟]山东省单县希望初级中学（北师大版）语文七年级上册作文：童年趣味范文初中篇",
          "suffixType": "doc",
          "size": 697,
          "updateTime": "2015-11-27",
          "documentType": {
              "id": 5,
              "name": "素材"
          },
          "stage": {
              "id": 3,
              "name": "初中"
          },
          "subject": {
              "id": 10,
              "name": "语文"
          },
          "version": {
              "id": 370,
              "name": "北师大版（2004）"
          },
          "downloadNum": 93,
          "viewNum": 392,
          "province": "山东省",
          "bookNodes": [
              {
                  "id": 35452,
                  "name": "综合复习与测试",
                  "pathIds": "35452"
              }
          ]
      }
    }
    `
  },
  'getDocumentDownloadUrl': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '文档接口', '获取普通文档资源下载地址'],
    title: '获取普通文档资源下载地址', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取普通文档资源下载地址', url: '/api/v1/invoke/documents/{documentId}/download-url', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Number', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'code',
          type: 'Int',
          description: '错误码： 1：表示正常；不等于1表示不正常，查看msg 信息' },
        { paras: 'msg', type: 'String', description: '请求结果' },
        { paras: 'data', type: 'Object', description: '请求结果数据' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": "http://jty-document.obs.cn-north-4.myhuaweicloud.com/2015-11/27/2015112715273734717.doc?Expires=1562122770&OSSAccessKeyId=LTAINPdmg9GsW51l&Signature=KSDYowi%2B02Vk2HbJ6lvW7genJpE%3D"
      }
    `
  },
  'getGoodDocumentList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '文档接口', '获取精品文档列表'],
    title: '获取精品文档列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取精品文档列表', url: '/api/v1/invoke/excellent-documents', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'booknode' },
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '选填', description: '章节id' },
        { paras: 'documentTypeId', type: 'Int', required: '选填', description: '文档类型id' },
        { paras: 'provinceId', type: 'Int', required: '选填', description: '省份id' },
        { paras: 'year', type: 'Int', required: '选填', description: '年份' },
        { paras: 'name', type: 'String', required: '选填', description: '文档名称关键字' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'orderby', type: 'Number', required: '可选', description: '排序字段，updateTime-按更新时间排序，viewNum-按浏览次数排序，collectNum-按收藏次数排序，downloadNum-按下载次数排序' },
        { paras: 'direction', type: 'Number', required: '可选', description: '排序字段，默认asc 正序-asc，倒序-desc' },
        { paras: 'versionId', type: 'Int', required: '可选', description: '版本id' }
      ]
    },
    YWRequestParamsErrorInfo: '注释：documentTypeId = 3 时,查询的是包含习题作业和试卷',
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'name ', type: 'String', description: '名称' },
        { paras: 'suffixType ', type: 'String', description: '文档后缀' },
        { paras: 'size ', type: 'String', description: '文档大小' },
        { paras: 'updateTime ', type: 'String', description: '文档更新时间' },
        { paras: 'downloadNum ', type: 'Int', description: '文档下载次数' },
        { paras: 'documentType ', type: 'Object', description: '文档类型' },
        { paras: 'province ', type: 'String', description: '文档省份' },
        { paras: 'stage ', type: 'Object', description: '文档所属学段' },
        { paras: 'subject ', type: 'Object', description: '文档所属学科' },
        { paras: 'grade ', type: 'Object', description: '文档所属年级' },
        { paras: 'version ', type: 'Object', description: '文档所属版本' },
        { paras: 'totalPages ', type: 'Int', description: '总页数' },
        { paras: 'totalElements ', type: 'Int', description: '总数' },
        { paras: 'numberOfElements ', type: 'Int', description: '每页显示条数' },
        { paras: 'sort ', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": {
              "content": [
                  {
                      "id": 8378713,
                      "name": "2022年历史人教版必修6素材浙江省",
                      "suffixType": "doc",
                      "size": 9,
                      "updateTime": "2019-12-02",
                      "documentType": {
                          "id": 5,
                          "name": "素材"
                      },
                      "stage": {
                          "id": 4,
                          "name": "高中"
                      },
                      "grade": {
                          "id": null,
                          "name": null
                      },
                      "subject": {
                          "id": 33,
                          "name": "历史"
                      },
                      "version": {
                          "id": 421,
                          "name": "人教版"
                      },
                      "downloadNum": 0,
                      "viewNum": 0,
                      "province": "浙江省",
                      "bookNodes": null
                  }
              ],
              "pageable": {
                  "sort": {
                      "sorted": true,
                      "unsorted": false
                  },
                  "offset": 0,
                  "pageSize": 20,
                  "pageNumber": 0,
                  "unpaged": false,
                  "paged": true
              },
              "totalElements": 1,
              "totalPages": 1,
              "last": true,
              "number": 0,
              "size": 20,
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "numberOfElements": 1,
              "first": true
          }
      }
    `
  },
  'getGoodDocumentDownloadUrl': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '文档接口', '获取精品文档资源下载地址'],
    title: '获取精品文档资源下载地址', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取精品文档资源下载地址', url: '/api/v1/invoke/excellent-documents/{documentId}/download-url', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Number', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'code',
          type: 'Int',
          description: '错误码： 1：表示正常；不等于1表示不正常，查看msg 信息' },
        { paras: 'msg', type: 'String', description: '请求结果' },
        { paras: 'data', type: 'Object', description: '请求结果数据' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data":"https://jty-document.obs.cn-north-4.myhuaweicloud.com/2019/2019-12-2/2019120230898680.doc?Expires=1591350760&OSSAccessKeyId=LTAINPdmg9GsW51l&Signature=byXJdHSKdKrMkcKs503ptlSGZBA%3D&response-content-type=application%2Fmsword"
    }
    `
  },
  'getAllDocList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '文档接口', '获取所有文档列表'],
    title: '获取所有文档列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取所有文档列表', url: '/api/v1/invoke/documents/all', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'searchType', type: 'String', required: '必填', description: 'booknode' },
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '选填', description: '章节id' },
        { paras: 'documentTypeId', type: 'Int', required: '选填', description: '文档类型id' },
        { paras: 'provinceId', type: 'Int', required: '选填', description: '省份id' },
        { paras: 'year', type: 'Int', required: '选填', description: '年份' },
        { paras: 'name', type: 'String', required: '选填', description: '文档名称关键字' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'orderby', type: 'Number', required: '可选', description: '排序字段，updateTime-按更新时间排序，viewNum-按浏览次数排序，collectNum-按收藏次数排序，downloadNum-按下载次数排序' },
        { paras: 'direction', type: 'Number', required: '可选', description: '排序字段，默认asc 正序-asc，倒序-desc' },
        { paras: 'versionId', type: 'Int', required: '可选', description: '版本id' }
      ]
    },
    YWRequestParamsErrorInfo: '注释：documentTypeId = 3 时,查询的是包含习题作业和试卷',
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'name ', type: 'String', description: '名称' },
        { paras: 'suffixType ', type: 'String', description: '文档后缀' },
        { paras: 'size ', type: 'String', description: '文档大小' },
        { paras: 'updateTime ', type: 'String', description: '文档更新时间' },
        { paras: 'downloadNum ', type: 'Int', description: '文档下载次数' },
        { paras: 'documentType ', type: 'object', description: '文档类型' },
        { paras: 'province ', type: 'String', description: '文档省份' },
        { paras: 'stage ', type: 'object', description: '文档所属学段' },
        { paras: 'subject ', type: 'object', description: '文档所属学科' },
        { paras: 'grade ', type: 'object', description: '文档所属年级' },
        { paras: 'version ', type: 'object', description: '文档所属版本' },
        { paras: 'origin ', type: 'object', dscription: '资源类型(1:普通， 2:精品)' },
        { paras: 'totalPages ', type: 'Int', description: '总页数' },
        { paras: 'totalElements ', type: 'Int', description: '总数' },
        { paras: 'numberOfElements ', type: 'Int', description: '每页显示条数' },
        { paras: 'sort ', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code":1,
          "msg":"成功",
          "data":{
              "content":[
                  {
                      "id":431376,
                      "name":"《一剪梅》 李清照 课件 （30张）",
                      "suffixType":"ppt",
                      "size":5,
                      "updateTime":"2015-12-12",
                      "documentType":{
                          "id":1,
                          "name":"课件"
                      },
                      "stage":{
                          "id":4,
                          "name":"高中"
                      },
                      "grade":{
                          "id":11,
                          "name":"高二"
                      },
                      "subject":{
                          "id":26,
                          "name":"语文"
                      },
                      "version":{
                          "id":313,
                          "name":"北师大版"
                      },
                      "downloadNum":129,
                      "viewNum":137,
                      "province":null,
                      "bookNodes":null,
                      "origin":1
                  },
                  {
                      "id":567585,
                      "name":"高中语文北师大版必修一3.9《再别康桥》课件 （共53张PPT）",
                      "suffixType":"ppt",
                      "size":2,
                      "updateTime":"2016-04-01",
                      "documentType":{
                          "id":1,
                          "name":"课件"
                      },
                      "stage":{
                          "id":4,
                          "name":"高中"
                      },
                      "grade":{
                          "id":10,
                          "name":"高一"
                      },
                      "subject":{
                          "id":26,
                          "name":"语文"
                      },
                      "version":{
                          "id":313,
                          "name":"北师大版"
                      },
                      "downloadNum":7,
                      "viewNum":30,
                      "province":null,
                      "bookNodes":null,
                      "origin":1
                  }
              ],
              "pageable":{
                  "sort":{
                      "sorted":true,
                      "unsorted":false
                  },
                  "pageSize":2,
                  "pageNumber":0,
                  "offset":0,
                  "unpaged":false,
                  "paged":true
              },
              "totalPages":35,
              "last":false,
              "totalElements":69,
              "first":true,
              "sort":{
                  "sorted":true,
                  "unsorted":false
              },
              "numberOfElements":2,
              "size":2,
              "number":0
          }
      }
    `
  },
  'getDocDownloadUrl': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '文档接口', '获取文档资源下载地址'],
    title: '获取文档资源下载地址', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档资源下载地址', url: '/api/v1/invoke/document/{documentId}/download/{origin}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Number', required: '必填', description: '文档id' },
        { paras: 'origin', type: 'Number', required: '必填', description: '资源类型(列表中的字段)' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'code',
          type: 'Int',
          description: '错误码： 1：表示正常；不等于1表示不正常，查看msg 信息' },
        { paras: 'msg', type: 'String', description: '请求结果' },
        { paras: 'data', type: 'Object', description: '请求结果数据' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code":1,
      "msg":"成功",
      "data":"https://jty-document.obs.cn-north-4.myhuaweicloud.com/2018-6/28/20180628174209081944.ppt?Expires=1595322421&OSSAccessKeyId=LTAINPdmg9GsW51l&Signature=4jtGsWp5UibIATCBHBN4uiEzgoU%3D&response-content-type=application%2Fvnd.ms-powerpoint"
    }
    `
  },
  'famousSchoolSwiper': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '名校接口', '获取名校轮播资源文档列表'],
    title: '获取名校轮播资源文档列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取名校轮播资源文档列表', url: '/api/v1/invoke/famousSchool/newestDocument', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'fileAddress ', type: 'String', description: '文件地址' },
        { paras: 'name ', type: 'String', description: '名称' },
        { paras: 'suffixType ', type: 'String', description: '文档后缀' },
        { paras: 'size ', type: 'String', description: '文档大小' },
        { paras: 'updateTime ', type: 'String', description: '文档更新时间' },
        { paras: 'downloadNum ', type: 'Int', description: '文档下载次数' },
        { paras: 'viewNum ', type: 'Int', description: '预览次数' },
        { paras: 'fabulousNum ', type: 'Int', description: '点赞次数' },
        { paras: 'collected ', type: 'Int', description: '收藏次数' },
        { paras: 'documentType ', type: 'object', description: '文档类型' },
        { paras: 'province ', type: 'String', description: '文档省份' },
        { paras: 'stage ', type: 'object', description: '文档所属学段' },
        { paras: 'subject ', type: 'object', description: '文档所属学科' },
        { paras: 'version ', type: 'object', description: '文档所属版本' },
        { paras: 'bookNodes ', type: 'List', description: '文档关联章节列表' },
        { paras: 'nrscSourceTypeDto ', type: 'object', description: '名校来源' },
        { paras: 'year ', type: 'String', description: '年份' },
        { paras: 'totalPages ', type: 'Int', description: '总页数' },
        { paras: 'totalElements ', type: 'Int', description: '总数' },
        { paras: 'numberOfElements ', type: 'Int', description: '每页显示条数' },
        { paras: 'sort ', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 8800628,
                "fileAddress": null,
                "name": "【百强】2019-2020学年安徽省合肥一中高三（上）9月月考 物理试卷（word精编版）",
                "suffixType": "rar",
                "size": 295,
                "author": "蔡元静",
                "updateTime": "2020-01-02",
                "documentType": {
                    "id": 3,
                    "name": "习题/作业"
                },
                "version": {
                    "id": null,
                    "name": null
                },
                "downloadNum": 8,
                "viewNum": 20,
                "fabulousNum": 0,
                "collected": false,
                "thumbs": false,
                "downloadIntegral": null,
                "isDownload": null,
                "stage": {
                    "id": 4,
                    "name": "高中"
                },
                "grade": {
                    "id": 12,
                    "name": "高三"
                },
                "subject": {
                    "id": 29,
                    "name": "物理"
                },
                "documentPaperType": {
                    "id": null,
                    "name": null
                },
                "nrscSourceDto": {
                    "id": 6,
                    "name": "合肥市第一中学",
                    "nrscSourceTypeDto": {
                        "id": 10,
                        "name": "学校"
                    },
                    "nrscSchoolLabelDto": {
                        "id": 1,
                        "name": "百强名校"
                    }
                },
                "columnName": null,
                "year": "2019"
            }
        ]
      }
    `
  },
  'famousSchoolInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '名校接口', '查询名校信息'],
    title: '查询名校信息', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '查询名校信息', url: '/api/v1/invoke/famousSchool/unionSchoolInfo/{sourceId}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'sourceId', type: 'Number', required: '必填', description: '名校id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'name ', type: 'String', description: '学校名称' },
        { paras: 'nrscSourceTypeDto ', type: 'Object', description: '学校类型' },
        { paras: 'nrscSchoolLabelDto ', type: 'Object', description: '学校标签' },
        { paras: 'sourceUrl ', type: 'String', description: '图片地址' },
        { paras: 'introduction ', type: 'String', description: '简介' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": {
            "id": 3,
            "name": "长郡中学",
            "nrscSourceTypeDto": {
                "id": 10,
                "name": "学校"
            },
            "nrscSchoolLabelDto": {
                "id": 1,
                "name": "百强名校"
            },
            "sourceUrl": "http://jty-tophundred-source.obs.cn-north-4.myhuaweicloud.com/2019/2019-12-24/2019122446322751.png",
            "introduction": "长沙市长郡中学(Changjun High School of Changsha)是一所由长沙市教育局主管的全日制公办普通高级中学，系湖南省示范性普通高级中学，湖南省首批挂牌的八所重点中学之一。长沙市长郡中学由长沙知府颜钟骥创建于1904年(清光绪三十年)，始称\"长沙府中学堂\"。1912年，在长沙府中学堂的基础上建立湖南长郡公立学校。此后，学校先后更名为湖南第一联合县立中学、长郡公学、湖南长郡",
            "documentNum": 10
        }
      }
    `
  },
  'famousSchool': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '名校接口', '获取名校资源文档列表'],
    title: '获取名校资源文档列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取名校资源文档列表', url: '/api/v1/invoke/famousSchool/documents', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '选填', description: '学科id' },
        { paras: 'provinceId', type: 'Int', required: '选填', description: '省份id' },
        { paras: 'name', type: 'String', required: '选填', description: '文档名称关键字' },
        { paras: 'gradeId', type: 'Int', required: '选填', description: '年级id' },
        { paras: 'type', type: 'Int', required: '选填', description: '类型：1:热门资源,2:百强名校,3:名校联盟,4:国家重点校' },
        { paras: 'sourceId', type: 'Int', required: '选填', description: '名校相关id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '默认值1，页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '分页大小，默认每页20条' },
        { paras: 'orderby', type: 'Number', required: '可选', description: '排序字段，updateTime-按更新时间排序，viewNum-按浏览次数排序，collectNum-按收藏次数排序，downloadNum-按下载次数排序' },
        { paras: 'direction', type: 'Number', required: '可选', description: '排序字段，默认asc 正序-asc，倒序-desc' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'fileAddress(不存数据) ', type: 'String', description: '文件地址(一直是null)' },
        { paras: 'name ', type: 'String', description: '名称' },
        { paras: 'suffixType ', type: 'String', description: '文档后缀' },
        { paras: 'size ', type: 'String', description: '文档大小' },
        { paras: 'updateTime ', type: 'String', description: '文档更新时间' },
        { paras: 'documentType ', type: 'Object', description: '文档类型' },
        { paras: 'totalPages ', type: 'Int', description: '总页数' },
        { paras: 'totalElements ', type: 'Int', description: '总数' },
        { paras: 'numberOfElements ', type: 'Int', description: '每页显示条数' },
        { paras: 'sort ', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": {
            "content": [
                {
                    "id": 8820492,
                    "fileAddress": null,
                    "name": "【百强】2019-2020年广西南宁市第三中学 高二（上）12月月考 地理试题（word版）",
                    "suffixType": "doc",
                    "size": 1184,
                    "author": "黄宁",
                    "updateTime": "2020-04-02",
                    "documentType": {
                        "id": 3,
                        "name": "习题/作业"
                    }
                }
            ],
            "pageable": {
                "sort": {
                    "sorted": true,
                    "unsorted": false
                },
                "pageSize": 10,
                "pageNumber": 0,
                "offset": 0,
                "unpaged": false,
                "paged": true
            },
            "totalPages": 125,
            "totalElements": 1246,
            "last": false,
            "first": true,
            "sort": {
                "sorted": true,
                "unsorted": false
            },
            "numberOfElements": 10,
            "size": 10,
            "number": 0
        }
      }
    `
  },
  'famousSchoolDoc': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '名校接口', '获取名校文档资源下载地址'],
    title: '获取名校文档资源下载地址', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '400px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档资源下载地址', url: '/api/v1/invoke/famousSchool/documents/{documentId}/download-url', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Number', required: '必填', description: '文档id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'code',
          type: 'Int',
          description: '错误码： 1：表示正常；不等于1表示不正常，查看msg 信息' },
        { paras: 'msg', type: 'String', description: '请求结果' },
        { paras: 'data', type: 'Object', description: '请求结果数据' }
      ]
    },
    showKeyIntroduct: false, // 是否显示字段解释
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": "http://jty-document.obs.cn-north-4.myhuaweicloud.com/2015-11/27/2015112715273734717.doc?Expires=1562122770&OSSAccessKeyId=LTAINPdmg9GsW51l&Signature=KSDYowi%2B02Vk2HbJ6lvW7genJpE%3D"
      }
    `
  },
  'microVideo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '微课接口', '获取微课视频列表'],
    title: '获取微课视频列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取微课视频列表', url: '/api/v1/invoke/videos', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectCategoryType', type: 'Iteger', required: '否', description: '学科类别id' },
        { paras: 'subjectId', type: 'Iteger', required: '是', description: '学科id' },
        { paras: 'knowledgePointId', type: 'Iteger', required: '否', description: '知识点id' },
        { paras: 'pageNumber', type: 'Iteger', required: '否', description: '页数' },
        { paras: 'pageSize', type: 'Iteger', required: '否', description: '每页条数' },
        { paras: 'name', type: 'String', required: '否', description: '视频名称' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'code', type: 'String', description: '阿里云id' },
        { paras: 'uploadTime', type: 'LocalDateTime', description: '上传时间' },
        { paras: 'title', type: 'Sring', description: '视频标题' },
        { paras: 'coverUrl', type: 'String', description: '视频封面' },
        { paras: 'stageId', type: 'Int', description: '学段id' },
        { paras: 'gradeId', type: 'Int', description: '年级id' },
        { paras: 'subjectId', type: 'Int', description: '学科id' },
        { paras: 'source', type: 'String', description: '来源' },
        { paras: 'version', type: 'String', description: '版本' },
        { paras: 'totalPages ', type: 'Int', description: '总页数' },
        { paras: 'totalElements ', type: 'Int', description: '总数' },
        { paras: 'numberOfElements ', type: 'Int', description: '每页显示条数' },
        { paras: 'sort ', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": {
            "content": [
                {
                    "id": 12660,
                    "code": "0d4780ec43904b5aa8c510459c05456f",
                    "uploadTime": "2020-03-26",
                    "title": "介绍“记忆宫殿”记忆法",
                    "coverUrl": "https://video.jtyjy.com/0d4780ec43904b5aa8c510459c05456f/snapshots/452679d8eed34b25a0bab9d2073bfb3f-00003.jpg",
                    "stageId": 2,
                    "gradeId": 3,
                    "subjectId": 3,
                    "source": "广西师范大学",
                    "version": "人教版"
                },
                {
                    "id": 12661,
                    "code": "50670794661840bebca29db086256d87",
                    "uploadTime": "2020-03-26",
                    "title": "使用“记忆宫殿”记忆汉字",
                    "coverUrl": "https://video.jtyjy.com/50670794661840bebca29db086256d87/snapshots/a2c6fbb622464935bd8f29b28d407333-00004.jpg",
                    "stageId": 2,
                    "gradeId": 4,
                    "subjectId": 3,
                    "source": "广西师范大学",
                    "version": "人教版"
                }
            ],
            "pageable": {
                "sort": {
                    "sorted": true,
                    "unsorted": false
                },
                "offset": 0,
                "pageSize": 2,
                "pageNumber": 0,
                "paged": true,
                "unpaged": false
            },
            "totalElements": 1742,
            "totalPages": 871,
            "last": false,
            "number": 0,
            "size": 2,
            "sort": {
                "sorted": true,
                "unsorted": false
            },
            "numberOfElements": 2,
            "first": true
        }
      }
    `
  },
  'microPlayCode': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '微课接口', '获取微课播放授权码'],
    title: '获取微课播放授权码', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取微课播放授权码', url: '/api/v1/invoke/media/play/{videoId}', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'videoId', type: 'Iteger', required: '是', description: '视频id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'code', type: 'String', description: '阿里云id' },
        { paras: 'uploadTime', type: 'LocalDateTime', description: '上传时间' },
        { paras: 'title', type: 'Sring', description: '视频标题' },
        { paras: 'coverUrl', type: 'String', description: '视频封面' },
        { paras: 'source', type: 'String', description: '来源' },
        { paras: 'duration', type: 'String', description: '时长' },
        { paras: 'playAuth', type: 'String', description: '播放视频授权码' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": {
            "playAuth": "eyJTZWN1cml0eVRva2VuIjoiQ0FJUzN3SjFxNkZ0NUIyeWZTaklyNWZUTC9qOG83UnkzSkc2U2t6MmdFcHNkT0ZIaHBmRGdEejJJSGxQZTNGaEFPb2V2L2svbVc5VTdmb2Nsck1xRnNNZUdCQ2JNcE12c01vSnJsN3dKcExGc3QySjZyOEpqc1ZWdXU5dHlsaXBzdlhKYXNEVkVma3VFNVhFTWlJNS8wMGU2TC8rY2lyWVhEN0JHSmFWaUpsaFE4MEtWdzJqRjFSdkQ4dFhJUTBRazYxOUszemRaOW1nTGlidWkzdnhDa1J2MkhCaWptOHR4cW1qL015UTV4MzFpMXYweStCM3dZSHRPY3FjYThCOU1ZMVdUc3Uxdm9oemFyR1Q2Q3BaK2psTStxQVU2cWxZNG1YcnM5cUhFa0ZOd0JpWFNaMjJsT2RpTndoa2ZLTTNOcmRacGZ6bjc1MUN0L2ZVaXA3OHhtUW1YNGdYY1Z5R0d0RHhrWk9aUXJ6emJZNWhLK2lnQVJtWGpJRFRiS3VTbWhnL2ZIY1dPRGxOZjljY01YSnFBWFF1TUdxRGNmRC9xUW1RT2xiK0cvWGFqUHBxajRBSjVsSHA3TWVNR1YrRGVMeVF5aDBFSWFVN2EwNDRxTDZvYnQ4WG1zUWFnQUUrMDZybElrM0xHRmc3dTRBZjBuTWxWVG5uaGM5L3BOMWw0ZjdqaitMZTUrcE9kOWxyOGpxaHArZHRJdHFXT1h4RzBEMkUwUTYrdnhHWUQ5SDNtQ0RLaFcrZFpxNlM4V3RJWUx0R1Z1TW5NTTRmWStMdlRlRHJZV2RXcm1HTVJUdzR0R2NZVEhwR2Z6czcranhRQkpvVFVoejFQemMzMWk2UWlNQU5PdTliMEE9PSIsIkF1dGhJbmZvIjoie1wiQ0lcIjpcInNPM01pZittNkNHVjI1Y2k4Y1ZIakxHNG1lSDAvZzZ2aWhWKzdIanYvRkNPNFBVQmV0ODNadnZNcVZpeEpma2xcXHJcXG5cIixcIkNhbGxlclwiOlwiTTFuenplN0QvOW1yT2xyby9IZ2xWVitqbElhWGhIeDNuakhzTnlOaHh6ST1cXHJcXG5cIixcIkV4cGlyZVRpbWVcIjpcIjIwMjAtMDYtMDhUMDY6Mzk6NTVaXCIsXCJNZWRpYUlkXCI6XCI4ZGU3YmRmM2RmZTI0NjIxYWE4Y2I0MTM3MzE0YzA0NlwiLFwiUGxheURvbWFpblwiOlwidmlkZW8uanR5ZWR1LmNvbVwiLFwiU2lnbmF0dXJlXCI6XCIwU0s3cE5oU21YRjFEblBXWGYvK29PbzdyN3c9XCJ9IiwiVmlkZW9NZXRhIjp7IlN0YXR1cyI6Ik5vcm1hbCIsIlZpZGVvSWQiOiI4ZGU3YmRmM2RmZTI0NjIxYWE4Y2I0MTM3MzE0YzA0NiIsIlRpdGxlIjoi5Lid57u45LmL6Lev5b6u6K++IiwiQ292ZXJVUkwiOiJodHRwczovL3ZpZGVvLmp0eWVkdS5jb20vOGRlN2JkZjNkZmUyNDYyMWFhOGNiNDEzNzMxNGMwNDYvc25hcHNob3RzLzJhMDUzY2FlODQwZDQ1NGJhNTc2ZmM0ZGUyN2NmZDc5LTAwMDAzLmpwZyIsIkR1cmF0aW9uIjozMjcuNzMzM30sIkFjY2Vzc0tleUlkIjoiU1RTLk5UZmRCSE5rU2tTUUhqR2RKOXhua2lSaGIiLCJQbGF5RG9tYWluIjoidmlkZW8uanR5ZWR1LmNvbSIsIkFjY2Vzc0tleVNlY3JldCI6IkV5cXNKS0tIblJyOXFXdzY5NGRTWXJhajQzZHdhdHhzNDd1ZUhja1pZRkZZIiwiUmVnaW9uIjoiY24tc2hhbmdoYWkiLCJDdXN0b21lcklkIjoxNTQzNTQ3NzA3NjY2NzU5fQ==",
            "duration": 327.7333,
            "title": "丝绸之路微课",
            "code": "8de7bdf3dfe24621aa8cb4137314c046",
            "coverUrl": "https://video.jtyjy.com/8de7bdf3dfe24621aa8cb4137314c046/snapshots/2a053cae840d454ba576fc4de27cfd79-00003.jpg",
            "browseCount": 7,
            "source": "崂山七中",
            "id": 6
        }
      }
    `
  },
  'microSubject': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '微课接口', '根据通用学段获取微课学科列表'],
    title: '根据通用学段获取微课学科列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '根据通用学段获取微课学科列表', url: '/api/v1/invoke/stage/{stageId}/micro-lesson-subjects', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Iteger', required: '是', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'name', type: 'String', description: '名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 3,
                "name": "语文"
            },
            {
                "id": 1,
                "name": "数学"
            },
            {
                "id": 2,
                "name": "英语"
            },
            {
                "id": 11,
                "name": "思品"
            },
            {
                "id": 8,
                "name": "信息技术"
            },
            {
                "id": 12,
                "name": "其他"
            }
        ]
      }
    `
  },
  'microKnow': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '微课接口', '根据微课学科获取微课知识点'],
    title: '根据微课学科获取微课知识点', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '380px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '根据微课学科获取微课知识点', url: '/api/v1/invoke/subject/{subjectId}/micro-lesson-knowledge-points', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Iteger', required: '是', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'name', type: 'String', description: '名称' },
        { paras: 'pathIds', type: 'String', description: '路径' },
        { paras: 'subjectId', type: 'Int', description: '学科id' },
        { paras: 'knowledgePointChildren', type: 'List', description: '子知识点' }
      ]
    },
    showResponseCode: true,
    responseCode: `
      {
        "code": 1,
        "msg": "成功",
        "data": [
            {
                "id": 53,
                "name": "汉语拼音",
                "pathIds": "53",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 54,
                "name": "识字与写字",
                "pathIds": "54",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 55,
                "name": "词语",
                "pathIds": "55",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 56,
                "name": "语句、修辞手法",
                "pathIds": "56",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 57,
                "name": "阅读理解",
                "pathIds": "57",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 58,
                "name": "古诗词",
                "pathIds": "58",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 59,
                "name": "习作",
                "pathIds": "59",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 60,
                "name": "其他",
                "pathIds": "60",
                "subjectId": 3,
                "knowledgePointChildren": null
            },
            {
                "id": 61,
                "name": "标点符号",
                "pathIds": "61",
                "subjectId": 3,
                "knowledgePointChildren": null
            }
        ]
      }
    `
  },
  'formulaEX': {
    showMathMlExample: true
  },
  'errorCode': {
    showErrorCode: true,
    errorCodeTable: {
      tableHead: [{
        prop: 'paras',
        width: '424px',
        align: 'center',
        label: '错误码'
      },
      {
        prop: 'description',
        width: '424px',
        align: 'center',
        label: '错误码描述'
      }],
      tableData: [
        { paras: '10001', description: '参数无效' },
        { paras: '10002', description: '参数为空' },
        { paras: '10003', description: '参数类型错误' },
        { paras: '10004', description: '参数缺失' },
        { paras: '20001', description: '用户未登录' },
        { paras: '20002', description: '账号不存在或密码错误' },
        { paras: '20003', description: '账号已被禁用' },
        { paras: '20004', description: '用户不存在' },
        { paras: '20008', description: '手机验证码错误' },
        { paras: '20009', description: '验证码错误' },
        { paras: '20100', description: '用户API调用信息不存在' },
        { paras: '30001', description: '某业务出现问题' },
        { paras: '40001', description: '系统繁忙，请稍后重试' },
        { paras: '50001', description: '数据未找到' },
        { paras: '50002', description: '数据有误' },
        { paras: '60001', description: '内部系统接口调用异常' },
        { paras: '60002', description: '当前输入的页数超过有效页数！' },
        { paras: '60003', description: '该接口禁止访问' },
        { paras: '60004', description: '接口地址无效' },
        { paras: '60005', description: '接口请求超时' },
        { paras: '60010', description: '已经超过接口调用次数限制' },
        { paras: '60011', description: '接口资源已被禁用' },
        { paras: '60012', description: '接口资源已过期' },
        { paras: '60013', description: '开通或续费的截止时间必须大于当前日期' },
        { paras: '60014', description: '已经超过试题调用数量限制' },
        { paras: '60015', description: '已经超过文档下载数量限制' },
        { paras: '60016', description: '已经超过名校下载数量限制' },
        { paras: '60017', description: '非法调用' },
        { paras: '60018', description: '已经超过微课下载数量限制' },
        { paras: '60019', description: '接口调用太频繁了' }
      ]
    }
  },
  'autograph': {
    showAutographContent: true, // 是否有内容介绍
    content1: `
      <p class="MsoNormal" style="color: #000;margin-top: 30px;text-indent: inherit;font-size: 12.0000pt;">第一步：确定接口请求参数</p>
      <p class="p" style="text-indent: inherit;margin-left: 0;"><span style=" color: #3a3a3a; font-size: 10.5000pt; ">首先：确认要调用的API接口及该接口的请求参数（不包括sign参数）。以“获取</span>科目列表接口<span style=" color: #3a3a3a; font-size: 10.5000pt; ">”为例，确定的请求参数为：stageId, accessKey、timestamp、nonce。如下图 </span></p>
    `,
    showTableImg: true,
    content2: `
      <p class="MsoNormal" style="text-indent: inherit;margin-bottom: 15px;font-size: 10.5000pt;">其次：创建参数表，Java示例代码如下</p>
    `,
    content3: `
    <table class="MsoTableGrid" style="width: 789px;border-collapse: collapse; border: none;" border="1" cellspacing="0" data-mce-style="border-collapse: collapse; border: none;" data-mce-selected="1"><tbody>
    <tr style="height: 172.4500pt;" data-mce-style="height: 172.4500pt;"><td style="width: 375.6000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;background: #ffffff; border: 1.0000pt solid windowtext;" valign="top" width="500" data-mce-style="width: 375.6000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;background: #ffffff; border: 1.0000pt solid windowtext;"><p class="pre" style="background: #ffffff;text-indent: inherit;"><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; ">// </span></em><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; ">开发者的</span></em><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; ">Access Key</span></em><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; ">和</span></em><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; ">Access Secret</span>
    </em><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; "><br></span></em><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">String clientId = </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"2020061843163893"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">;</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; "><br></span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">String clientSecret = </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"50979096c4ac493b9103a74b997ae463"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">;</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; "><br></span>
    <span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">String apiUrl = </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"https://fuwu-open.jkxjxw.com/v1/api/stage/{stageId}/subjects"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">;</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; "><br></span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; "><br></span><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; ">//</span></em><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; ">
    创建参数表</span></em><em><span style=" color: #808080; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #808080; font-style: italic; font-size: 10.5000pt; "><br></span></em><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">Map&lt;String, String&gt; paramMap = </span><strong><span style=" color: #000080; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #000080; font-weight: bold; font-size: 10.5000pt; ">new </span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">HashMap&lt;&gt;();</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; "><br></span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">paramMap.put(</span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"accessKey"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">, clientId);</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">
    <br></span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">paramMap.put(</span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"timestamp"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">, </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"1597222275617"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">);</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; "><br></span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style="
    color: #000000; font-size: 10.5000pt; ">paramMap.put(</span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"nonce"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">, </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"534523523589"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">);</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; "><br>
    </span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">paramMap.put(</span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"stageId"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">, </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"2"</span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">);</span></p><p class="MsoNormal"><br></p></td></tr></tbody></table>
    `,
    content4: `
      <p class="MsoNormal" style="margin-top: 15px;padding: 0;"><span style="font-size: 10.5000pt;">注意：生成签名时，需要使用开发者的clientId合clientSecret(登录开放平台，个人中心获取)</span></p>
      <p class="MsoNormal" style="line-height: 10px; " data-mce><span style="font-size: 10.5000pt;">&nbsp;</span></p>
      <p class="MsoNormal" style="padding: 0; ">第二步：对请求参数进行字典排序并生成待签名的字符串</span></p>
      <p class="MsoNormal" style="text-indent: inherit;">对之前确认的参数，根据参数名称在ASC</span>ll码表中的顺序进行排序，将排序后的参数与其对应值组合成“参数=参数值”的格式，并且把这些参数用“&amp;”字符连接起来，然后将开发者的clientSecret进行拼接， 生成待签名字符串</p>
      <p class="MsoNormal" style="margin: 0;line-height: 10px;"><span style="font-size: 10.5000pt;">&nbsp;</span></p>
      <p class="MsoNormal" style="text-indent: inherit;"><span style="font-size: 10.5000pt;">&nbsp;</span><span style="font-size: 10.5000pt;">java代码示例如下：</span></p>
      <table class="MsoTableGrid" style="width: 789px;border-collapse: collapse;  border: none;" border="1" cellspacing="0" data-mce-style="border-collapse: collapse;  border: none;" data-mce-selected="1">
      <tbody><tr><td style="width: 414.8000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;border: 1.0000pt solid windowtext;" valign="top" width="553" data-mce-style="width: 414.8000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;border: 1.0000pt solid windowtext;"><p class="pre" style="padding: 0;background: #ffffff;"><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">String needEncryptString</span><span style="font-family: 微软雅黑; mso-fareast-font-family: 宋体;  color: #000000; font-size: 10.0000pt;  background: #f8f8f8; mso-shading: #f8f8f8;" data-mce-style="font-family: 微软雅黑; mso-fareast-font-family: 宋体;  color: #000000; font-size: 10.0000pt;  background: #f8f8f8; mso-shading: #f8f8f8;">&nbsp;</span><span style="
       color: #000000; font-size: 10.5000pt; ">= params == </span><strong><span style=" color: #000080; font-weight: bold; font-size: 10.5000pt; ">null </span></strong><span style=" color: #000000; font-size: 10.5000pt; ">? </span></p><p class="pre" style="text-indent: inherit;background: #ffffff;"><strong><span style=" color: #000080; font-weight: bold; font-size: 10.5000pt; ">null </span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">:</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">&nbsp;</span><strong><span style=" color: #000080; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #000080; font-weight: bold; font-size: 10.5000pt; ">new </span></strong>
      <span style=" color: #000000; font-size: 10.5000pt; ">ArrayList&lt;&gt;(</span><span style=" color: #000000; font-size: 10.5000pt; ">&nbsp;paramMap</span><span style=" color: #000000; font-size: 10.5000pt; ">.keySet()).stream().sorted()</span></p><p class="pre" style="text-indent: inherit;background: #ffffff;"><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">.filter(t -&gt; </span><span style=" color: #660e7a; font-size: 10.5000pt; " data-mce-style=" color: #660e7a; font-size: 10.5000pt; ">params</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">.get(t) != </span><strong><span style=" color: #000080; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #000080; font-weight: bold; font-size: 10.5000pt; ">null </span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">|| !</span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">""</span></strong><span style=" color: #000000; font-size: 10.5000pt; "
      data-mce-style=" color: #000000; font-size: 10.5000pt; ">.equals(</span><span style=" color: #660e7a; font-size: 10.5000pt; " data-mce-style=" color: #660e7a; font-size: 10.5000pt; ">params</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">.get(t))).map(t -&gt; t + </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"=" </span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">+ </span><span style=" color: #660e7a; font-size: 10.5000pt; " data-mce-style="font-family: 等线;
       color: #660e7a; font-size: 10.5000pt; ">params</span><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">.get(t)).collect(Collectors.</span><em><span style=" color: #000000; font-style: italic; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-style: italic; font-size: 10.5000pt; ">joining</span></em><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">(</span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"&amp;"</span></strong><span style=" color: #000000;
      font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">)) + </span><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">"&amp;</span></strong><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">s</span></strong><strong><span style=" color: #008000; font-weight: bold; font-size: 10.5000pt; " data-mce-style=" color: #008000; font-weight: bold; font-size: 10.5000pt; ">ecretKey=" </span></strong><span style=" color: #000000; font-size: 10.5000pt; " data-mce-style=" color: #000000; font-size: 10.5000pt; ">+secret;
      </span></p><p class="MsoNormal"><br></p></td></tr></tbody></table>
    `,
    content5: `
      <p class="MsoNormal">第三步：将代签名的字符串加密，生成对应的sign签名</p>
      <p class="MsoNormal">对待签名字符串进行SHA-1计算加密，生成sign签名。Java示例代码如下：</p>
      <table class="MsoTableGrid" style="width: 789px;border-collapse: collapse; border: none;" border="1" cellspacing="0"><tbody><tr><td style="width: 393.7500pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;border: 1.0000pt solid windowtext;" valign="top" width="525" data-mce-style="width: 393.7500pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;border: 1.0000pt solid windowtext;"><p class="MsoNormal"><span style="font-size: 10.5000pt;">//&nbsp;SHA1计算&nbsp;&nbsp;&nbsp;</span></p><p class="pre" style="background: #ffffff;">
      <span style="font-size: 10.5000pt;">String&nbsp;</span><span style="font-size: 10.5000pt;">sign</span><span style="font-size: 10.5000pt;">&nbsp;= SignUtil.sha1(needEncryptString);</span></p></td></tr></tbody></table><p class="MsoNormal"><span style="font-size: 10.5000pt;">&nbsp;</span></p><p class="MsoNormal" data-mce>其中SignUtil工具类，java代码如下：</p><table class="MsoTableGrid" style="width: 789px;border-collapse: collapse;  border: none;" border="1" cellspacing="0" data-mce-style="border-collapse: collapse;  border: none;" data-mce-selected="1"><tbody><tr><td style="width: 393.8000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;border: 1.0000pt solid windowtext;" valign="top" width="525" data-mce-style="width: 393.8000pt; padding: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;border: 1.0000pt solid windowtext;"><p class="pre" style="background: #ffffff;"><strong>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">public class </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">SignUtil {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span></p><p class="pre" style="text-indent: 24.0000pt; mso-char-indent-count: 2.0000; background: #ffffff;" data-mce-style="text-indent: 24.0000pt; mso-char-indent-count: 2.0000; background: #ffffff;"><em><span style="font-family: 宋体; mso-ascii-font-family: Consolas; mso-hansi-font-family: Consolas; color: #808080; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: 宋体; mso-ascii-font-family: Consolas; mso-hansi-font-family: Consolas; color: #808080; font-style: italic; font-size: 12.0000pt; ">//<span style="font-family: 宋体;">生成签名</span></span></em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">public static </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">String sha1(String str) </span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">throws </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">IOException {</span>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">return </span></strong><em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; ">byte2hex</span></em>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(</span><em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; ">getShA1Digest</span></em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(str));</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;}</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">private static byte</span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">[] getShA1Digest(String data) </span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">throws </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">IOException {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">byte</span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">[] bytes;</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">try </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">{</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MessageDigest md = MessageDigest.</span><em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; ">getInstance</span></em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #008000; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #008000; font-weight: bold; font-size: 12.0000pt; ">"SHA-1"</span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">);</span>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;bytes = md.digest(data.getBytes(StandardCharsets.</span><strong><em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #660e7a; font-weight: bold; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #660e7a; font-weight: bold; font-style: italic; font-size: 12.0000pt; ">UTF_8</span></em></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">));</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;} </span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">catch </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(GeneralSecurityException gse) {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">throw new </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">IOException(gse);</span>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">return </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">bytes;</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;}</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br>
      </span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">private static </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">String byte2hex(</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">byte</span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">[] bytes) {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;StringBuilder sign = </span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">new </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">StringBuilder();</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">for </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">byte </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">aByte : bytes) {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;String hex = Integer.</span><em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-style: italic; font-size: 12.0000pt; ">toHexString</span></em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(aByte &amp; </span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; ">0xFF</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">);</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">if </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(hex.length() == </span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; ">1</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">) {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sign.append(</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #008000; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #008000; font-weight: bold; font-size: 12.0000pt; ">"0"</span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">);</span>
      <span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sign.append(hex.toUpperCase());</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">return </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">sign.toString();</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;}</span></p><p class="pre" style="background: #ffffff;"><span style="font-family: 宋体; mso-ascii-font-family: Consolas; mso-hansi-font-family: Consolas; color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: 宋体; mso-ascii-font-family: Consolas; mso-hansi-font-family: Consolas; color: #000000; font-size: 12.0000pt; ">&nbsp;</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;</span></p>
      <p class="pre" style="margin-left: 24.0000pt; text-indent: -24.0000pt;background: #ffffff;"><span style="font-family: Consolas;color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;</span><em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #808080; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #808080; font-style: italic; font-size: 12.0000pt; ">//</span></em><em><span style="font-family: 宋体; color: #808080; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: 宋体; color: #808080; font-style: italic; font-size: 12.0000pt; ">生成有限位数的随机数（最长</span></em><em><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #808080; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #808080; font-style: italic; font-size: 12.0000pt; ">20</span></em><em><span style="font-family: 宋体; color: #808080; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: 宋体; color: #808080; font-style: italic; font-size: 12.0000pt; ">位）</span></em><em><span style="font-family: 宋体; color: #808080; font-style: italic; font-size: 12.0000pt; " data-mce-style="font-family: 宋体; color: #808080; font-style: italic; font-size: 12.0000pt; "><br></span></em><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">public static </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">String getRandomNickname(</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">int </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">length) {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">int </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">maxLength = </span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; ">20</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">;</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">if </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(length &gt; maxLength) {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;length = maxLength;</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;}</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;StringBuilder val = </span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">new </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">StringBuilder();</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;Random random = </span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;
      color: #000080; font-weight: bold; font-size: 12.0000pt; ">new </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">Random();</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">for </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">(</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">int </span></strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">i = </span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; ">0</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">; i &lt; length; i++) {</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;val.append(random.nextInt(</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #0000ff; font-size: 12.0000pt; ">10</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">));</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;}</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000080; font-weight: bold; font-size: 12.0000pt; ">return </span>
      </strong><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">val.toString();</span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; "><br></span><span style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: Consolas; mso-fareast-font-family: 宋体;  color: #000000; font-size: 12.0000pt; ">}</span></p><p class="MsoNormal"><span style="font-family: 宋体; mso-ascii-font-family: Consolas; mso-hansi-font-family: Consolas; color: #000000; font-size: 12.0000pt; " data-mce-style="font-family: 宋体; mso-ascii-font-family: Consolas; mso-hansi-font-family: Consolas; color: #000000; font-size: 12.0000pt; ">}</span></p></td></tr></tbody></table><div id="mceResizeHandlenw" data-mce-bogus="all" class="mce-resizehandle" unselectable="true" data-mce-style="cursor: nw-resize; margin: 0px; padding: 0px; left: 32.5px; top: 193.5px;" style="cursor: nw-resize; margin: 0px; padding: 0px; left: 32.5px; top: 193.5px;"></div><div id="mceResizeHandlene" data-mce-bogus="all" class="mce-resizehandle" unselectable="true" data-mce-style="cursor: ne-resize; margin: 0px; padding: 0px; left: 480.5px; top: 193.5px;" style="cursor: ne-resize; margin: 0px; padding: 0px; left: 480.5px; top: 193.5px;"></div><div id="mceResizeHandlese" data-mce-bogus="all" class="mce-resizehandle" unselectable="true" data-mce-style="cursor: se-resize; margin: 0px; padding: 0px; left: 480.5px; top: 1445.5px;" style="cursor: se-resize; margin: 0px; padding: 0px; left: 480.5px; top: 1445.5px;"></div><div id="mceResizeHandlesw" data-mce-bogus="all" class="mce-resizehandle" unselectable="true" data-mce-style="cursor: sw-resize; margin: 0px; padding: 0px; left: 32.5px; top: 1445.5px;" style="cursor: sw-resize; margin: 0px; padding: 0px; left: 32.5px; top: 1445.5px;"></div>
    `
  }
}



// WEBPACK FOOTER //
// ./src/pages/front/dev-document/data.js